export var CommonTestAttributes;
(function (CommonTestAttributes) {
    CommonTestAttributes["Unknown"] = "unknown";
    CommonTestAttributes["Duration"] = "duration";
    CommonTestAttributes["Discount"] = "discount";
    CommonTestAttributes["Checkbox"] = "checkbox";
    CommonTestAttributes["AddButton"] = "component_addButton";
    CommonTestAttributes["FlatDiscount"] = "flatDiscount";
    CommonTestAttributes["TimeSelectHour"] = "timeSelect_hour";
    CommonTestAttributes["TimeSelectMinutes"] = "timeSelect_minutes";
    CommonTestAttributes["TableSelectFilter"] = "table_selectFilter";
    CommonTestAttributes["PlanFormLegalSelect"] = "planForm_legalSelect";
    CommonTestAttributes["PlanFormIndividualSelect"] = "planForm_individualSelect";
    CommonTestAttributes["PopupCloseButton"] = "popup_closeButton";
    CommonTestAttributes["PopupSubmitButton"] = "popup_submitButton";
    CommonTestAttributes["PopupCancelButton"] = "popup_cancelButton";
    CommonTestAttributes["MobileCardButton"] = "mobileCard_button";
    CommonTestAttributes["SaveButton"] = "saveButton";
    CommonTestAttributes["CancelButton"] = "cancelButton";
    CommonTestAttributes["RemoveButton"] = "removeButton";
    CommonTestAttributes["ArchiveButton"] = "archiveButton";
    CommonTestAttributes["ButtonWithDescription"] = "buttonWithDescription";
    CommonTestAttributes["ActionsButton"] = "actions_button";
    CommonTestAttributes["SelectedRowsActionButton"] = "selectedRows_actionButton";
    CommonTestAttributes["CheckboxSelectInput"] = "checkboxSelect_input";
    CommonTestAttributes["EditableFieldInput"] = "editableField_input";
    CommonTestAttributes["CheckboxWithTextInput"] = "checkboxWithText_input";
    CommonTestAttributes["QuantityInput"] = "quantity_input";
    CommonTestAttributes["TableColumnFilter"] = "table_columnFilter";
    CommonTestAttributes["ActionsCreateTask"] = "actions_createTask";
    CommonTestAttributes["ActionsImportLaboratoryServices"] = "actions_importLaboratoryServices";
    CommonTestAttributes["ActionsImportLaboratoryServicePrices"] = "actions_importLaboratoryServicePrices";
    CommonTestAttributes["ActionsCreateEntry"] = "actions_createEntry";
    CommonTestAttributes["DiagnosticDescribingPageTabsOpen"] = "diagnosticDescribingPage_tabs_open";
    CommonTestAttributes["DiagnosticDescribingPageTabsMyActive"] = "diagnosticDescribingPage_tabs_myActive";
    CommonTestAttributes["FileDragAndDropLoad"] = "fileDragAndDrop_load";
    CommonTestAttributes["RightMenuCrossIcon"] = "rightMenu_crossIcon";
    CommonTestAttributes["ActionButton"] = "meatball_actionButton";
    CommonTestAttributes["SlideLeft"] = "slider_left";
    CommonTestAttributes["SlideRight"] = "slider_right";
    CommonTestAttributes["FoldingContentOpener"] = "foldingContent_opener";
    CommonTestAttributes["HeaderBackButton"] = "header_backButton";
})(CommonTestAttributes || (CommonTestAttributes = {}));
export var LeftMenuAttributes;
(function (LeftMenuAttributes) {
    LeftMenuAttributes["Dashboard"] = "leftMenu_dashboard";
    LeftMenuAttributes["Patient"] = "leftMenu_patient";
    LeftMenuAttributes["Schedule"] = "leftMenu_schedule";
    LeftMenuAttributes["Billing"] = "leftMenu_billing";
    LeftMenuAttributes["Certificate"] = "leftMenu_certificate";
    LeftMenuAttributes["Setting"] = "leftMenu_setting";
    LeftMenuAttributes["Template"] = "leftMenu_template";
    LeftMenuAttributes["Notification"] = "leftMenu_notification";
    LeftMenuAttributes["User"] = "leftMenu_user";
    LeftMenuAttributes["Organization"] = "leftMenu_organization";
    LeftMenuAttributes["Services"] = "leftMenu_services";
    LeftMenuAttributes["ServicesNew"] = "leftMenu_servicesNew";
    LeftMenuAttributes["PriceList"] = "leftMenu_priceList";
    LeftMenuAttributes["PriceListView"] = "leftMenu_priceListView";
    LeftMenuAttributes["Plan"] = "leftMenu_plan";
    LeftMenuAttributes["FeatureFlag"] = "leftMenu_featureFlag";
    LeftMenuAttributes["UiTranslations"] = "leftMenu_UiTranslations";
    LeftMenuAttributes["AttachmentStatus"] = "leftMenu_attachmentStatus";
    LeftMenuAttributes["AssistanceSetting"] = "leftMenu_assistanceSetting";
    LeftMenuAttributes["LaboratoryAdmin"] = "leftMenu_laboratory-admin";
    LeftMenuAttributes["Accounting"] = "leftMenu_accounting";
    LeftMenuAttributes["FinanceConfiguration"] = "leftMenu_financeConfiguration";
    LeftMenuAttributes["BC"] = "leftMenu_bc";
    LeftMenuAttributes["Prompts"] = "leftMenu_prompts";
    LeftMenuAttributes["Clinics"] = "leftMenu_clinics";
    LeftMenuAttributes["Support"] = "leftMenu_support";
    LeftMenuAttributes["WalkIn"] = "leftMenu_walkIn";
    LeftMenuAttributes["DataIsolation"] = "leftMenu_dataIsolation";
})(LeftMenuAttributes || (LeftMenuAttributes = {}));
export var SupportWidgetTestAttributes;
(function (SupportWidgetTestAttributes) {
    SupportWidgetTestAttributes["Root"] = "supportWidget_root";
    SupportWidgetTestAttributes["CloseButton"] = "supportWidget_closeButton";
    SupportWidgetTestAttributes["TicketList"] = "supportWidget_ticketList";
    SupportWidgetTestAttributes["NewTicketButton"] = "supportWidget_newTicketButton";
    SupportWidgetTestAttributes["NewTicketForm"] = "supportWidget_newTicketForm";
    SupportWidgetTestAttributes["TicketTitleInput"] = "supportWidget_ticketTitleInput";
    SupportWidgetTestAttributes["CreateTicketButton"] = "supportWidget_createTicketButton";
    SupportWidgetTestAttributes["CancelCreateTicketButton"] = "supportWidget_cancelCreateTicketButton";
    SupportWidgetTestAttributes["LoadMoreTicketsButton"] = "supportWidget_loadMoreTicketsButton";
    SupportWidgetTestAttributes["Ticket"] = "supportWidget_ticket";
    SupportWidgetTestAttributes["TicketDetail"] = "supportWidget_ticketDetail";
    SupportWidgetTestAttributes["BackButton"] = "supportWidget_backButton";
    SupportWidgetTestAttributes["LoadOlderMessagesButton"] = "supportWidget_loadOlderMessagesButton";
    SupportWidgetTestAttributes["MessageInput"] = "supportWidget_messageInput";
    SupportWidgetTestAttributes["Error"] = "supportWidget_error";
    SupportWidgetTestAttributes["TicketHeader"] = "supportWidget_ticketHeader";
    SupportWidgetTestAttributes["EmptyStateAction"] = "supportWidget_emptyStateAction";
    SupportWidgetTestAttributes["MessageLengthCounter"] = "supportWidget_messageLengthCounter";
    SupportWidgetTestAttributes["AttachmentChip"] = "supportWidget_attachmentChip";
    SupportWidgetTestAttributes["AttachmentInput"] = "supportWidget_attachmentInput";
})(SupportWidgetTestAttributes || (SupportWidgetTestAttributes = {}));
export var DurationFormDataTestIds;
(function (DurationFormDataTestIds) {
    DurationFormDataTestIds["Root"] = "durationForm";
    DurationFormDataTestIds["StartDateInput"] = "durationForm_startDateInput";
    DurationFormDataTestIds["EndDateWrapper"] = "durationForm_endDateWrapper";
    DurationFormDataTestIds["EndDateInput"] = "durationForm_endDateInput";
    DurationFormDataTestIds["DurationSelectWrapper"] = "durationForm_durationSelectWrapper";
    DurationFormDataTestIds["DurationSelect"] = "durationForm_durationSelect";
})(DurationFormDataTestIds || (DurationFormDataTestIds = {}));
// Schedule page attributes
export var SchedulePageTestAttributes;
(function (SchedulePageTestAttributes) {
    SchedulePageTestAttributes["FillerComment"] = "schedulePage_fillerComment";
})(SchedulePageTestAttributes || (SchedulePageTestAttributes = {}));
// Service Risk page attributes
export var ServiceRiskPageTestAttributes;
(function (ServiceRiskPageTestAttributes) {
    ServiceRiskPageTestAttributes["RiskValue"] = "serviceRiskPage_riskValue";
})(ServiceRiskPageTestAttributes || (ServiceRiskPageTestAttributes = {}));
// Service page attributes
export var ServicePageTestAttributes;
(function (ServicePageTestAttributes) {
    ServicePageTestAttributes["RequirementSearchInput"] = "serviceRequirementPage_searchInput";
    ServicePageTestAttributes["GroupCreateButton"] = "serviceGroupPage_createButton";
    ServicePageTestAttributes["GroupCancelButton"] = "serviceGroupPage_cancelButton";
    ServicePageTestAttributes["GroupName"] = "serviceGroupPage_name";
    ServicePageTestAttributes["ServiceSelect"] = "servicePage_serviceSelect";
    ServicePageTestAttributes["MainSpecialtySelect"] = "servicePage_mainSpecialtySelect";
    ServicePageTestAttributes["SpecialtySelect"] = "servicePage_specialtySelect";
    ServicePageTestAttributes["RequirementSelect"] = "servicePage_requirementSelect";
    ServicePageTestAttributes["TypeSelect"] = "servicePage_typeSelect";
    ServicePageTestAttributes["LoadCSV"] = "servicePage_loadCSV";
    ServicePageTestAttributes["AddServiceButton"] = "servicePage_addServiceButton";
    ServicePageTestAttributes["UpdatePrice"] = "servicePage_updatePrice";
    ServicePageTestAttributes["PrintPriceList"] = "servicePage_printPriceList";
    ServicePageTestAttributes["PrintIndividualPriceList"] = "servicePage_printIndividualPriceList";
    ServicePageTestAttributes["SearchButton"] = "servicePage_searchButton";
    ServicePageTestAttributes["AddButton"] = "servicePage_addButton";
    ServicePageTestAttributes["SearchInput"] = "servicePage_searchInput";
    ServicePageTestAttributes["StatusFilter"] = "servicePage_statusFilter";
    ServicePageTestAttributes["CategoryFilter"] = "servicePage_categoryFilter";
    ServicePageTestAttributes["LoadCsv"] = "servicePage_loadCsv";
})(ServicePageTestAttributes || (ServicePageTestAttributes = {}));
export var ServicePageTableCreationMenu;
(function (ServicePageTableCreationMenu) {
    ServicePageTableCreationMenu["Button"] = "servicePageTableCreationMenu_button";
    ServicePageTableCreationMenu["SaveButton"] = "servicePageTableCreationMenu_buttonSave";
    ServicePageTableCreationMenu["CancelButton"] = "servicePageTableCreationMenu_buttonCancel";
})(ServicePageTableCreationMenu || (ServicePageTableCreationMenu = {}));
export var ServiceRequirementPageTable;
(function (ServiceRequirementPageTable) {
    ServiceRequirementPageTable["EditButton"] = "serviceRequirementPageTable_editButton";
    ServiceRequirementPageTable["SearchInput"] = "serviceRequirementPageTable_searchInput";
    ServiceRequirementPageTable["SearchButton"] = "serviceRequirementPageTable_searchButton";
})(ServiceRequirementPageTable || (ServiceRequirementPageTable = {}));
export var ComplicatedServicePageTableCreationMenu;
(function (ComplicatedServicePageTableCreationMenu) {
    ComplicatedServicePageTableCreationMenu["Button"] = "complicatedServicePageTableCreationMenu_button";
    ComplicatedServicePageTableCreationMenu["SaveButton"] = "complicatedServicePageTableCreationMenu_buttonSave";
    ComplicatedServicePageTableCreationMenu["CancelButton"] = "complicatedServicePageTableCreationMenu_buttonCancel";
})(ComplicatedServicePageTableCreationMenu || (ComplicatedServicePageTableCreationMenu = {}));
// Medical case page attributes
export var MedicalCasePageTestAttributes;
(function (MedicalCasePageTestAttributes) {
    MedicalCasePageTestAttributes["Name"] = "medicalCaseForm_name";
    MedicalCasePageTestAttributes["DoctorSelect"] = "medicalCaseForm_doctorSelect";
    MedicalCasePageTestAttributes["Description"] = "medicalCaseForm_description";
    MedicalCasePageTestAttributes["CopyButton"] = "medicalCaseForm_copyButton";
    MedicalCasePageTestAttributes["CancelButton"] = "medicalCaseForm_cancelButton";
    MedicalCasePageTestAttributes["SaveButton"] = "medicalCaseForm_saveButton";
    MedicalCasePageTestAttributes["RemoveButton"] = "medicalCaseForm_removeButton";
    MedicalCasePageTestAttributes["ToggleHoldButton"] = "medicalCaseForm_toggleHoldButton";
    MedicalCasePageTestAttributes["CloseButton"] = "medicalCaseForm_closeButton";
    MedicalCasePageTestAttributes["ReopenButton"] = "medicalCaseForm_reopenButton";
    MedicalCasePageTestAttributes["TakeCaseButton"] = "medicalCaseForm_takeCaseButton";
    MedicalCasePageTestAttributes["AddSameButton"] = "medicalCaseForm_addSameButton";
    MedicalCasePageTestAttributes["ActionButton"] = "medicalCaseForm_actionButton";
    MedicalCasePageTestAttributes["CreateNewButton"] = "medicalCaseForm_createNewButton";
    MedicalCasePageTestAttributes["EditButton"] = "medicalCaseForm_editButton";
    MedicalCasePageTestAttributes["ResumeButton"] = "medicalCaseForm_resumeButton";
    MedicalCasePageTestAttributes["SuspendButton"] = "medicalCaseForm_suspendButton";
    MedicalCasePageTestAttributes["EndButton"] = "medicalCaseForm_endButton";
    MedicalCasePageTestAttributes["Manager"] = "medicalCaseForm_manager";
})(MedicalCasePageTestAttributes || (MedicalCasePageTestAttributes = {}));
// MedicalCaseList attributes
export var MedicalCaseListPageTestAttributes;
(function (MedicalCaseListPageTestAttributes) {
    MedicalCaseListPageTestAttributes["PatientFilter"] = "medicalCaseListPage_patientFilter";
    MedicalCaseListPageTestAttributes["ManagersFilter"] = "medicalCaseListPage_managersFilter";
    MedicalCaseListPageTestAttributes["StatusFilter"] = "medicalCaseListPage_statusFilter";
    MedicalCaseListPageTestAttributes["AcceptFilterButtons"] = "medicalCaseListPage_acceptFilterButtons";
})(MedicalCaseListPageTestAttributes || (MedicalCaseListPageTestAttributes = {}));
// User Entry Template page attributes
export var UserEntryTypeTemplateTestAttributes;
(function (UserEntryTypeTemplateTestAttributes) {
    UserEntryTypeTemplateTestAttributes["Textarea"] = "userValueTemplate_textarea";
    UserEntryTypeTemplateTestAttributes["Value"] = "userValueTemplate_value";
    UserEntryTypeTemplateTestAttributes["Remove"] = "userValueTemplate_remove";
    UserEntryTypeTemplateTestAttributes["UseTemplate"] = "userValueTemplate_useTemplate";
    UserEntryTypeTemplateTestAttributes["FieldSelect"] = "userValueTemplate_fieldSelect";
    UserEntryTypeTemplateTestAttributes["ShowForPatient"] = "userValueTemplate_showForPatient";
    UserEntryTypeTemplateTestAttributes["HideFromPatient"] = "userValueTemplate_hideFromPatient";
})(UserEntryTypeTemplateTestAttributes || (UserEntryTypeTemplateTestAttributes = {}));
// Entry page attributes
export var EntryPageTestAttributes;
(function (EntryPageTestAttributes) {
    EntryPageTestAttributes["EditNote"] = "entryPage_editNote_textarea";
    EntryPageTestAttributes["Transcription"] = "entryPage_transcription_text";
    EntryPageTestAttributes["TranscriptionResultsTabs"] = "entryPage_transcriptionResults_tabs";
    EntryPageTestAttributes["TranscriptionResultsAddAllButton"] = "entryPage_transcriptionResults_addAllButton";
    EntryPageTestAttributes["TranscriptionResultsCloseButton"] = "entryPage_transcriptionResults_closeButton";
    EntryPageTestAttributes["TranscriptionItemAddButton"] = "entryPage_transcriptionItem_addButton";
    EntryPageTestAttributes["TranscriptionItemExcludeButton"] = "entryPage_transcriptionItem_excludeButton";
    EntryPageTestAttributes["TranscriptionItemRestoreButton"] = "entryPage_transcriptionItem_restoreButton";
    EntryPageTestAttributes["TranscriptionItemUpdateButton"] = "entryPage_transcriptionItem_updateButton";
    EntryPageTestAttributes["TranscriptionEpisodeSelect"] = "entryPage_transcriptionEpisode_select";
    EntryPageTestAttributes["TranscriptionEpisodeAddButton"] = "entryPage_transcriptionEpisode_addButton";
    EntryPageTestAttributes["TranscriptionEpisodeLink"] = "entryPage_transcriptionEpisode_link";
    EntryPageTestAttributes["Approval"] = "entryPage_approval_textarea";
    EntryPageTestAttributes["ApprovalButton"] = "entryPage_approval_button";
    EntryPageTestAttributes["SearchTemplate"] = "entryPage_valueTemplate_search";
    EntryPageTestAttributes["AddTemplateButton"] = "entryPage_valueTemplate_template";
    EntryPageTestAttributes["SearchService"] = "entryPage_header_searchService";
    EntryPageTestAttributes["SendEmailButton"] = "entryPage_header_sendEmeilButton";
    EntryPageTestAttributes["Email"] = "entryPage_header_email";
    EntryPageTestAttributes["EditButton"] = "entryHeader_edit";
    EntryPageTestAttributes["SignButton"] = "entryHeader_sign";
    EntryPageTestAttributes["HeaderList"] = "entryHeader_list";
    EntryPageTestAttributes["ShortConclusion"] = "entryHeader_shortConclusion";
    EntryPageTestAttributes["Conclusion"] = "entryHeader_conclusion";
    EntryPageTestAttributes["EntryHeaderEntryType"] = "entryHeader_entryType";
    EntryPageTestAttributes["EntryHeaderReservationType"] = "entryHeader_reservationType";
    EntryPageTestAttributes["Print"] = "entryHeader_print";
    EntryPageTestAttributes["SignEDS"] = "entryHeader_signEDS";
    EntryPageTestAttributes["SendIDS"] = "entryHeader_sendIDS";
    EntryPageTestAttributes["PrintIDS"] = "entryHeader_printIDS";
    EntryPageTestAttributes["PrintLabel"] = "entryHeader_printLabel";
    EntryPageTestAttributes["PrintIndividualReport"] = "entryHeader_printIndividualReport";
    EntryPageTestAttributes["AddExaminationLink"] = "entryHeader_addExaminationLink";
    EntryPageTestAttributes["ChangeDate"] = "entryHeader_changeDate";
    EntryPageTestAttributes["ChangeDoctor"] = "entryHeader_changeDoctor";
    EntryPageTestAttributes["ChangeEntryData"] = "entryHeader_changeEntryData";
    EntryPageTestAttributes["TranslationEntry"] = "entryHeader_translationEntry";
    EntryPageTestAttributes["SendEmail"] = "entryHeader_sendEmail";
    EntryPageTestAttributes["Versions"] = "entryHeader_versions";
    EntryPageTestAttributes["SendContacts"] = "entryHeader_sendContacts";
    EntryPageTestAttributes["BackButton"] = "entryHeader_backButton";
    EntryPageTestAttributes["ReplyReferral"] = "entryPage_reply";
    EntryPageTestAttributes["DecreaseReferralReply"] = "entryPage_decreaseReferralReply";
    EntryPageTestAttributes["IncrementReferralReply"] = "entryPage_incrementReferralReply";
    EntryPageTestAttributes["ReplayCountInput"] = "entryPage_replyCountInput";
    EntryPageTestAttributes["ReservationSelect"] = "entryPage_reservationSelect";
    EntryPageTestAttributes["SelectField"] = "entryPage_selectField";
    EntryPageTestAttributes["MultiSelectField"] = "entryPage_multiSelectField";
    EntryPageTestAttributes["IDSServiceSelect"] = "entryPage_IDSServiceSelect";
    EntryPageTestAttributes["NestedEntryTypeSelect"] = "entryPage_nestedEntryTypeSelect";
    EntryPageTestAttributes["ValueTemplateSelection"] = "entryPage_valueTemplateSelection";
    EntryPageTestAttributes["CreateTemplateButton"] = "entryPage_createTemplateButton";
    EntryPageTestAttributes["CreateCommonTemplateButton"] = "entryPage_createCommonTemplateButton";
    EntryPageTestAttributes["ToggleModeButton"] = "entryPage_toggleModeButton";
    EntryPageTestAttributes["AddSubTemplateButton"] = "entryPage_addSubTemplateButton";
    EntryPageTestAttributes["UnreplyReferralButton"] = "entryPage_unreplyReferralButton";
    EntryPageTestAttributes["AddRenderedService"] = "entryPage_addRenderedService";
    EntryPageTestAttributes["AddSubscription"] = "entryPage_addSubscription";
    EntryPageTestAttributes["CreateMedicalCase"] = "entryPage_createMedicalCase";
    EntryPageTestAttributes["AddDiagnosis"] = "entryPage_addDiagnosis";
    EntryPageTestAttributes["ShowMoreCases"] = "entryPage_showMoreCases";
    EntryPageTestAttributes["AttacheMedicalCase"] = "entryPage_attacheMedicalCase";
    EntryPageTestAttributes["EditMedicalCases"] = "entryPage_editMedicalCases";
    EntryPageTestAttributes["RemoveMedicalCases"] = "entryPage_removeMedicalCases";
    EntryPageTestAttributes["DetachMedicalCases"] = "entryPage_detachMedicalCases";
    EntryPageTestAttributes["ContentNav"] = "entryPage_contentNav";
    EntryPageTestAttributes["AvailableReferralOpener"] = "entryPage_availableReferralOpener";
    EntryPageTestAttributes["TreatmentPlanOpener"] = "entryPage_treatmentPlanOpener";
    EntryPageTestAttributes["MedicalCaseDiagnosesOpener"] = "entryPage_medicalCaseDiagnosesOpener";
    EntryPageTestAttributes["MedicalCaseOpener"] = "entryPage_medicalCaseOpener";
    EntryPageTestAttributes["MenuItemOpener"] = "entryPage_menuItemOpener";
    EntryPageTestAttributes["ExpandHideMedicalCases"] = "entryPage_expandHideMedicalCases";
    EntryPageTestAttributes["EntryPopupConfirmButton"] = "entryPage_popup_confirmButton";
    EntryPageTestAttributes["EntryPopupCloseButton"] = "entryPage_popup_closeButton";
    EntryPageTestAttributes["CurrentDoctorSelect"] = "entryPage_rightMenu_currentDoctorSelect";
    EntryPageTestAttributes["ChooseDoctorAsyncSelect"] = "entryPage_rightMenu_doctorAsyncSelect";
    EntryPageTestAttributes["ChooseDoctorSelect"] = "entryPage_rightMenu_doctorSelect";
    EntryPageTestAttributes["EntrySendMessagePopupConfirmButton"] = "entryPage_sendMessagePopup_confirmButton";
    EntryPageTestAttributes["EntrySendMessagePopupCancelButton"] = "entryPage_sendMessagePopup_cancelButton";
    EntryPageTestAttributes["EntrySendMessageTextArea"] = "entryPage_sendMessage_textarea";
    EntryPageTestAttributes["NextTabButton"] = "entryPage_nextTabButton";
    EntryPageTestAttributes["PrevTabButton"] = "entryPage_prevTabButton";
})(EntryPageTestAttributes || (EntryPageTestAttributes = {}));
export var EntryTranslationPageTestAttributes;
(function (EntryTranslationPageTestAttributes) {
    EntryTranslationPageTestAttributes["AutoTranslateButton"] = "entryTranslationPage_autoTranslateButton";
})(EntryTranslationPageTestAttributes || (EntryTranslationPageTestAttributes = {}));
// Entry Opener attributes
export var EntryPageOpenerTestAttributes;
(function (EntryPageOpenerTestAttributes) {
    EntryPageOpenerTestAttributes["Episodes"] = "entryPage_menuItemOpener_episodes";
    EntryPageOpenerTestAttributes["NotesOpener"] = "entryPage_menuItemOpener_notes";
    EntryPageOpenerTestAttributes["TranscriptionOpener"] = "entryPage_menuItemOpener_transcription";
    EntryPageOpenerTestAttributes["Translate"] = "entryPage_menuItemOpener_translate";
    EntryPageOpenerTestAttributes["TemplatesOpener"] = "entryPage_menuItemOpener_templates";
    EntryPageOpenerTestAttributes["FilesOpener"] = "entryPage_menuItemOpener_files";
    EntryPageOpenerTestAttributes["ServiceInformedConsent"] = "entryPage_menuItemOpener_serviceInformedConsent";
    EntryPageOpenerTestAttributes["AvailableReferralsOpener"] = "entryPage_availableReferralOpener";
    EntryPageOpenerTestAttributes["LaboratoryReferralsOpener"] = "entryPage_laboratoryReferralOpener";
    EntryPageOpenerTestAttributes["OpenedCaseBySpecialityOpener"] = "entryPage_openedCase_bySpecialityOpener";
    EntryPageOpenerTestAttributes["OpenedCaseOtherOpener"] = "entryPage_openedCase_otherOpener";
    EntryPageOpenerTestAttributes["EntryMedicalCaseOpener"] = "entryPage_entryMedicalCaseOpener";
    EntryPageOpenerTestAttributes["FilesDownloadAll"] = "entryPage_filesDownloadAll";
    EntryPageOpenerTestAttributes["FilesShowAll"] = "entryPage_filesShowAll";
})(EntryPageOpenerTestAttributes || (EntryPageOpenerTestAttributes = {}));
// RenderedService page attributes
export var EhrRenderedServicePageTestAttributes;
(function (EhrRenderedServicePageTestAttributes) {
    EhrRenderedServicePageTestAttributes["PaymentComment"] = "ehrRenderedServicePage_paymentComment";
    EhrRenderedServicePageTestAttributes["BlockComment"] = "ehrRenderedServicePage_blockComment";
    EhrRenderedServicePageTestAttributes["BlockEhrButton"] = "ehrRenderedServicePage_blockEhrButton";
    EhrRenderedServicePageTestAttributes["UnBlockEhrButton"] = "ehrRenderedServicePage_unBlockEhrButton";
    EhrRenderedServicePageTestAttributes["PaymentTable"] = "ehrRenderedServicePage_paymentTable";
    EhrRenderedServicePageTestAttributes["RefundTable"] = "ehrRenderedServicePage_refundTable";
    EhrRenderedServicePageTestAttributes["InProcessTable"] = "ehrRenderedServicePage_inProcessTable";
    EhrRenderedServicePageTestAttributes["ButtonWriteComment"] = "ehrRenderedServicePage_buttonWriteComment";
    EhrRenderedServicePageTestAttributes["TableTabs"] = "ehrRenderedServicePage_tableTabs";
    EhrRenderedServicePageTestAttributes["ChangeStatusButton"] = "ehrRenderedServicePage_changeStatusButton";
    EhrRenderedServicePageTestAttributes["PaymentButton"] = "ehrRenderedServicePage_paymentButton";
})(EhrRenderedServicePageTestAttributes || (EhrRenderedServicePageTestAttributes = {}));
// Organization page attributes
export var OrganizationPageTestAttributes;
(function (OrganizationPageTestAttributes) {
    OrganizationPageTestAttributes["Name"] = "organizationPage_name";
    OrganizationPageTestAttributes["NameTranslation"] = "organizationPage_nameTranslation";
    OrganizationPageTestAttributes["MainDoctorSelect"] = "organizationPage_mainDoctorSelect";
    OrganizationPageTestAttributes["Timezone"] = "organizationPage_timezone";
    OrganizationPageTestAttributes["Phone"] = "organizationPage_phone";
    OrganizationPageTestAttributes["Site"] = "organizationPage_site";
    OrganizationPageTestAttributes["INN"] = "organizationPage_inn";
    OrganizationPageTestAttributes["KPP"] = "organizationPage_kpp";
    OrganizationPageTestAttributes["Address"] = "organizationPage_address";
    OrganizationPageTestAttributes["Bank"] = "organizationPage_bank";
    OrganizationPageTestAttributes["Bic"] = "organizationPage_bic";
    OrganizationPageTestAttributes["OKPO"] = "organizationPage_okpo";
    OrganizationPageTestAttributes["Account"] = "organizationPage_account";
    OrganizationPageTestAttributes["CorAccount"] = "organizationPage_corAccount";
    OrganizationPageTestAttributes["WayHere"] = "organizationPage_wayHere";
    OrganizationPageTestAttributes["Agreement"] = "organizationPage_agreement";
    OrganizationPageTestAttributes["EmailsInvoices"] = "organizationPage_emailsInvoices";
    OrganizationPageTestAttributes["EmailsNotification"] = "organizationPage_emailsNotification";
    OrganizationPageTestAttributes["EmailsConclusions"] = "organizationPage_emailsConclusions";
    OrganizationPageTestAttributes["Emails"] = "organizationPage_emails";
    OrganizationPageTestAttributes["InsuranceOrganizationSelect"] = "organizationPage_insuranceOrganizationSelect";
    OrganizationPageTestAttributes["RequiresEdsForEntries"] = "organizationPage_requiresEdsForEntries";
})(OrganizationPageTestAttributes || (OrganizationPageTestAttributes = {}));
export var OrganizationWorkTimeTabAttributes;
(function (OrganizationWorkTimeTabAttributes) {
    OrganizationWorkTimeTabAttributes["AddWorkTime"] = "organizationWorkTime_addWorkTime";
    OrganizationWorkTimeTabAttributes["WorkTimeCard"] = "organizationWorkTime_workTimeCard";
    OrganizationWorkTimeTabAttributes["AddExceptionRule"] = "organizationWorkTime_addExceptionRule";
    OrganizationWorkTimeTabAttributes["ExceptionRuleCard"] = "organizationWorkTime_exceptionRuleCard";
})(OrganizationWorkTimeTabAttributes || (OrganizationWorkTimeTabAttributes = {}));
// Legal entity page attributes
export var LegalEntityPageTestAttributes;
(function (LegalEntityPageTestAttributes) {
    LegalEntityPageTestAttributes["Name"] = "legalEntityPage_name";
    LegalEntityPageTestAttributes["Abbreviation"] = "legalEntityPage_abbreviation";
    LegalEntityPageTestAttributes["ExternalId"] = "legalEntityPage_externalId";
    LegalEntityPageTestAttributes["Country"] = "legalEntityPage_country";
    LegalEntityPageTestAttributes["Phone"] = "legalEntityPage_phone";
    LegalEntityPageTestAttributes["Site"] = "legalEntityPage_site";
    LegalEntityPageTestAttributes["INN"] = "legalEntityPage_inn";
    LegalEntityPageTestAttributes["KPP"] = "legalEntityPage_kpp";
    LegalEntityPageTestAttributes["RegistrationNumber"] = "legalEntityPage_registrationNumber";
    LegalEntityPageTestAttributes["Address"] = "legalEntityPage_address";
    LegalEntityPageTestAttributes["Bank"] = "legalEntityPage_bank";
    LegalEntityPageTestAttributes["Bic"] = "legalEntityPage_bic";
    LegalEntityPageTestAttributes["OKPO"] = "legalEntityPage_okpo";
    LegalEntityPageTestAttributes["Account"] = "legalEntityPage_account";
    LegalEntityPageTestAttributes["CorAccount"] = "legalEntityPage_corAccount";
    LegalEntityPageTestAttributes["Agreement"] = "legalEntityPage_agreement";
    LegalEntityPageTestAttributes["EmailsInvoices"] = "legalEntityPage_emailsInvoices";
    LegalEntityPageTestAttributes["EmailsNotification"] = "legalEntityPage_emailsNotification";
    LegalEntityPageTestAttributes["EmailsConclusions"] = "legalEntityPage_emailsConclusions";
    LegalEntityPageTestAttributes["Emails"] = "legalEntityPage_emails";
    LegalEntityPageTestAttributes["AccountantList"] = "legalEntityPage_accountantList";
    LegalEntityPageTestAttributes["InsuranceOrganizationSelect"] = "legalEntityPage_insuranceOrganizationSelect";
    LegalEntityPageTestAttributes["DefaultFinnedFrom"] = "legalEntityPage_defaultFinnedFrom";
    LegalEntityPageTestAttributes["CloseBillingPeriodAfter"] = "legalEntityPage_closeBillingPeriodAfter";
    LegalEntityPageTestAttributes["EditInformedConsentForServices"] = "legalEntityPage_editInformedConsentForServices";
    LegalEntityPageTestAttributes["EditInformedConsentForPatients"] = "legalEntityPage_editInformedConsentForPatients";
})(LegalEntityPageTestAttributes || (LegalEntityPageTestAttributes = {}));
// Organization Schedule page attributes
export var OrganizationSchedulePageAttributes;
(function (OrganizationSchedulePageAttributes) {
    OrganizationSchedulePageAttributes["MakeScheduleButton"] = "organizationSchedulePage_makeScheduleButton";
    OrganizationSchedulePageAttributes["SaveButton"] = "organizationSchedulePage_saveButton";
    OrganizationSchedulePageAttributes["CancelButton"] = "organizationSchedulePage_cancelButton";
    OrganizationSchedulePageAttributes["ShowAssistan"] = "organizationSchedulePage_showAssistan";
})(OrganizationSchedulePageAttributes || (OrganizationSchedulePageAttributes = {}));
// MySubscriptions page attributes
export var MySubscriptionsPageAttributes;
(function (MySubscriptionsPageAttributes) {
    MySubscriptionsPageAttributes["PatientSelect"] = "mySubscriptionsPage_patientSelect";
    MySubscriptionsPageAttributes["RepresentativesSelect"] = "mySubscriptionsPage_representativesSelect";
    MySubscriptionsPageAttributes["Comment"] = "mySubscriptionsPage_comment";
    MySubscriptionsPageAttributes["AddButton"] = "mySubscriptionsPage_addButton";
    MySubscriptionsPageAttributes["CancelButton"] = "mySubscriptionsPage_cancelButton";
    MySubscriptionsPageAttributes["ReturnButton"] = "mySubscriptionsPage_returnButton";
    MySubscriptionsPageAttributes["CreateButton"] = "mySubscriptionsPage_createButton";
    MySubscriptionsPageAttributes["PatientFilterSelect"] = "mySubscriptionsPage_patientFilterSelect";
    MySubscriptionsPageAttributes["StatusFilterSelect"] = "mySubscriptionsPage_statusFilterSelect";
    MySubscriptionsPageAttributes["ApplyFilterButton"] = "mySubscriptionsPage_applyFilterButton";
    MySubscriptionsPageAttributes["ResetFilterButton"] = "mySubscriptionsPage_resetFilterButton";
    MySubscriptionsPageAttributes["FilterButton"] = "mySubscriptionsPage_filterButton";
    MySubscriptionsPageAttributes["AddSubscriptionButton"] = "mySubscriptionsPage_addSubscriptionButton";
    MySubscriptionsPageAttributes["ShowServicesButton"] = "mySubscriptionsPage_showServicesButton";
    MySubscriptionsPageAttributes["SelectFilterInsuranceCompany"] = "mySubscriptionsPage_selectFilterInsuranceCompany";
    MySubscriptionsPageAttributes["SelectFilterProgram"] = "mySubscriptionsPage_selectFilterProgram";
    MySubscriptionsPageAttributes["SelectFilterStatus"] = "mySubscriptionsPage_selectFilterStatus";
    MySubscriptionsPageAttributes["SelectInsuranceCompany"] = "mySubscriptionsPage_selectInsuranceCompany";
    MySubscriptionsPageAttributes["SelectProgram"] = "mySubscriptionsPage_selectProgram";
    MySubscriptionsPageAttributes["SelectUser"] = "mySubscriptionsPage_selectUser";
    MySubscriptionsPageAttributes["ProgramSaveButton"] = "mySubscriptionsPage_programSaveButton";
    MySubscriptionsPageAttributes["ProgramCancelButton"] = "mySubscriptionsPage_programCancelButton";
    MySubscriptionsPageAttributes["InputPolicyNumber"] = "mySubscriptionsPage_inputPolicyNumber";
    MySubscriptionsPageAttributes["InputPolicyNumberCopy"] = "mySubscriptionsPage_inputPolicyNumberCopy";
    MySubscriptionsPageAttributes["InputPhoneNumber"] = "mySubscriptionsPage_inputPhoneNumber";
    MySubscriptionsPageAttributes["InputEmail"] = "mySubscriptionsPage_inputEmail";
    MySubscriptionsPageAttributes["InputShare"] = "mySubscriptionsPage_inputShare";
    MySubscriptionsPageAttributes["InputNewProgramTitle"] = "mySubscriptionsPage_inputNewProgramTitle";
    MySubscriptionsPageAttributes["ButtonCreateProgram"] = "mySubscriptionsPage_buttonCreateProgram";
    MySubscriptionsPageAttributes["ButtonCreateGuarantee"] = "mySubscriptionsPage_buttonCreateGuarantee";
    MySubscriptionsPageAttributes["TextAreaNewProgramConditions"] = "mySubscriptionsPage_textAreaNewProgramConditions";
})(MySubscriptionsPageAttributes || (MySubscriptionsPageAttributes = {}));
export var VaccinationPageAttributes;
(function (VaccinationPageAttributes) {
    VaccinationPageAttributes["VaccinationTable"] = "vaccinationPage_table";
})(VaccinationPageAttributes || (VaccinationPageAttributes = {}));
// VaccinationMenu attributes
export var VaccinationMenuAttributes;
(function (VaccinationMenuAttributes) {
    VaccinationMenuAttributes["VaccinationDate"] = "vaccinationMenu_vaccinationDate";
    VaccinationMenuAttributes["Disease"] = "vaccinationMenu_disease";
    VaccinationMenuAttributes["Vaccine"] = "vaccinationMenu_vaccine";
    VaccinationMenuAttributes["Dose"] = "vaccinationMenu_dose";
    VaccinationMenuAttributes["Series"] = "vaccinationMenu_series";
    VaccinationMenuAttributes["ExpirationDate"] = "vaccinationMenu_expirationDate";
    VaccinationMenuAttributes["Stage"] = "vaccinationMenu_stage";
    VaccinationMenuAttributes["InjectionSite"] = "vaccinationMenu_injectionSite";
    VaccinationMenuAttributes["DeliveryMethod"] = "vaccinationMenu_deliveryMethod";
    VaccinationMenuAttributes["Reaction"] = "vaccinationMenu_reaction";
    VaccinationMenuAttributes["Comment"] = "vaccinationMenu_comment";
    VaccinationMenuAttributes["SaveButton"] = "vaccinationMenu_saveButton";
    VaccinationMenuAttributes["CancelButton"] = "vaccinationMenu_cancelButton";
    VaccinationMenuAttributes["RemoveButton"] = "vaccinationMenu_removeButton";
    VaccinationMenuAttributes["ResetFilterButton"] = "vaccinationMenu_resetFilterButton";
    VaccinationMenuAttributes["AddButton"] = "vaccinationMenu_addButton";
    VaccinationMenuAttributes["PrintCertificateButton"] = "vaccinationMenu_printCertificateButton";
    VaccinationMenuAttributes["PrintLanguagePopup"] = "vaccinationMenu_printLanguagePopup";
    VaccinationMenuAttributes["AddDataButton"] = "vaccinationMenu_addDataButton";
    VaccinationMenuAttributes["FilterButton"] = "vaccinationMenu_filterButton";
    VaccinationMenuAttributes["RemoveDocumentButton"] = "vaccinationMenu_removeDocumentButton";
})(VaccinationMenuAttributes || (VaccinationMenuAttributes = {}));
// TaskRightMenu attributes
export var TaskAttributes;
(function (TaskAttributes) {
    TaskAttributes["RejectionComment"] = "task_rejectionComment";
    TaskAttributes["Description"] = "task_description";
    TaskAttributes["Type"] = "task_type";
    TaskAttributes["ToDo"] = "task_toDo";
    TaskAttributes["Comment"] = "task_comment";
    TaskAttributes["Name"] = "task_name";
    TaskAttributes["Requester"] = "task_requester";
    TaskAttributes["Executor"] = "task_executor";
    TaskAttributes["Practice"] = "task_practice";
    TaskAttributes["AssigneeType"] = "task_assigneeType";
    TaskAttributes["CreateDate"] = "task_createDate";
    TaskAttributes["CreateTime"] = "task_createTime";
    TaskAttributes["Date"] = "task_date";
    TaskAttributes["EndDate"] = "task_endDate";
    TaskAttributes["Time"] = "task_time";
    TaskAttributes["ParticipantSelect"] = "task_participantSelect";
    TaskAttributes["Urgency"] = "task_urgency";
    TaskAttributes["UrgencySelect"] = "task_urgencySelect";
    TaskAttributes["ExecuteButton"] = "task_executeButton";
    TaskAttributes["CancelRemoveButtons"] = "task_cancelRemoveButtons";
    TaskAttributes["Add"] = "task_add";
    TaskAttributes["Cancel"] = "task_cancel";
    TaskAttributes["Save"] = "task_save";
    TaskAttributes["Delete"] = "task_delete";
    TaskAttributes["Accept"] = "task_accept";
    TaskAttributes["Reject"] = "task_reject";
    TaskAttributes["Close"] = "task_close";
    TaskAttributes["MarkComplete"] = "task_markComplete";
    TaskAttributes["MarkNotComplete"] = "task_markNotComplete";
    TaskAttributes["CancelComplete"] = "task_cancelComplete";
    TaskAttributes["PatientInfo"] = "task_patientInfo";
    TaskAttributes["PatientInfoSelect"] = "task_patientInfoSelect";
    TaskAttributes["EpisodeOfCare"] = "task_episodeOfCare";
    TaskAttributes["EpisodeOfCareSelect"] = "task_episodeOfCareSelect";
})(TaskAttributes || (TaskAttributes = {}));
// InsuranceMenu attributes
export var InsuranceMenuAttributes;
(function (InsuranceMenuAttributes) {
    InsuranceMenuAttributes["OrganizationSelect"] = "insuranceMenu_organizationSelect";
    InsuranceMenuAttributes["ExecutorSelect"] = "insuranceMenu_executorSelect";
    InsuranceMenuAttributes["CoExecutorSelect"] = "insuranceMenu_coExecutorSelect";
    InsuranceMenuAttributes["Comment"] = "insuranceMenu_comment";
    InsuranceMenuAttributes["SaveButton"] = "insuranceMenu_saveButton";
    InsuranceMenuAttributes["RemoveButton"] = "insuranceMenu_removeButton";
})(InsuranceMenuAttributes || (InsuranceMenuAttributes = {}));
// RenderedService attributes
export var RenderedServiceAttributes;
(function (RenderedServiceAttributes) {
    RenderedServiceAttributes["OrganizationSelect"] = "renderedService_organizationSelect";
    RenderedServiceAttributes["ExecutorSelect"] = "renderedService_executorSelect";
    RenderedServiceAttributes["CoExecutorSelect"] = "renderedService_coExecutorSelect";
    RenderedServiceAttributes["ToothNumber"] = "renderedService_toothNumber";
    RenderedServiceAttributes["Comment"] = "renderedService_comment";
    RenderedServiceAttributes["LegalPlanSelect"] = "renderedService_legalPlanSelect";
    RenderedServiceAttributes["GpOrganizationSelect"] = "renderedService_gpOrganizationSelect";
    RenderedServiceAttributes["IndividualPlanSelect"] = "renderedService_individualPlanSelect";
    RenderedServiceAttributes["SaveButton"] = "renderedService_saveButton";
    RenderedServiceAttributes["RemoveButton"] = "renderedService_removeButton";
    RenderedServiceAttributes["CancelButton"] = "renderedService_cancelButton";
})(RenderedServiceAttributes || (RenderedServiceAttributes = {}));
// Referral attributes
export var ReferralAttributes;
(function (ReferralAttributes) {
    ReferralAttributes["DetachButton"] = "referral_detachButton";
    ReferralAttributes["RemoveButton"] = "referral_removeButton";
    ReferralAttributes["SaveButton"] = "referral_saveButton";
    ReferralAttributes["EditLabDetailButton"] = "referral_editLabDetailButton";
    ReferralAttributes["ToothNumber"] = "referral_toothNumber";
    ReferralAttributes["Comment"] = "referral_comment";
    ReferralAttributes["LaboratorySelect"] = "referral_laboratorySelect";
    ReferralAttributes["LaboratoryCodeSelect"] = "referral_laboratoryCodeSelect";
    ReferralAttributes["BioCodeSelect"] = "referral_bioCodeSelect";
    ReferralAttributes["LaboratoryOptionInput"] = "referral_laboratoryOptionInput";
    ReferralAttributes["AddGroupName"] = "referral_addGroupName";
    ReferralAttributes["AddGroupCancelConfirm"] = "referral_addGroupCancelConfirm";
    ReferralAttributes["LegalPlanSelect"] = "referral_legalPlanSelect";
    ReferralAttributes["InsuranceOrganizationSelect"] = "referral_insuranceOrganizationSelect";
    ReferralAttributes["IndividualPlan"] = "referral_individualPlan";
    ReferralAttributes["Discount"] = "referral_discount";
    ReferralAttributes["FlatDiscount"] = "referral_flatDiscount";
    ReferralAttributes["DoctorSelect"] = "referral_doctorSelect";
    ReferralAttributes["SaveLabButton"] = "referral_saveLabButton";
    ReferralAttributes["CancelSaveLabButton"] = "referral_cancelSaveLabButton";
    ReferralAttributes["ContractorSelect"] = "referral_contractorSelect";
    ReferralAttributes["SaveContractorButton"] = "referral_saveContractorButton";
    ReferralAttributes["ReferringDoctorSelect"] = "referral_referringDoctorSelect";
    ReferralAttributes["OrganizationSelect"] = "referral_organizationSelect";
    ReferralAttributes["AddButton"] = "referral_addButton";
    ReferralAttributes["UnreplyButton"] = "referral_unreplyButton";
    ReferralAttributes["FavoriteAddButton"] = "referral_favorite_addButton";
    ReferralAttributes["FavoriteAddSelectedButton"] = "referral_favorite_addSelectedButton";
    ReferralAttributes["FavoriteCreateGroupButton"] = "referral_favorite_CreateGroupButton";
    ReferralAttributes["FavoriteGroupActionButton"] = "referral_favorite_groupActionButton";
    ReferralAttributes["FavoriteGroupCard"] = "referral_favorite_groupCard";
    ReferralAttributes["CancelSearchClick"] = "referral_cancelSearchClick";
    ReferralAttributes["CreateReferralSearchInput"] = "createReferral_searchInput";
    ReferralAttributes["IsUrgent"] = "referral_isUrgent";
    ReferralAttributes["CreationMenu"] = "referral_creationMenu";
    ReferralAttributes["CreateReferralAddButton"] = "createReferral_addButton";
    ReferralAttributes["CreateReferralPrice"] = "createReferral_price";
    ReferralAttributes["AddCardServiceName"] = "createReferral_AddCardServiceName";
    ReferralAttributes["Card"] = "referral_card";
})(ReferralAttributes || (ReferralAttributes = {}));
// AstraShare Form attributes
export var AstraShareAttributes;
(function (AstraShareAttributes) {
    AstraShareAttributes["WelcomeMessage"] = "astraShareForm_welcomeMessage";
    AstraShareAttributes["CancelConfirmButtons"] = "astraShareForm_buttons";
    AstraShareAttributes["CreateLinkButton"] = "astraShareForm_createLinkButton";
})(AstraShareAttributes || (AstraShareAttributes = {}));
// FavoriteRecommendation attributes
export var RecommendationAttributes;
(function (RecommendationAttributes) {
    RecommendationAttributes["CreateFavoriteButton"] = "recommendation_createFavoriteButton";
    RecommendationAttributes["IsImportantCheckbox"] = "recommendation_isImportantCheckbox";
    RecommendationAttributes["Comment"] = "recommendation_comment";
    RecommendationAttributes["SaveButton"] = "recommendation_saveButton";
    RecommendationAttributes["RemoveButton"] = "recommendation_removeButton";
    RecommendationAttributes["AddCancelButtons"] = "recommendation_addCancelButtons";
    RecommendationAttributes["AddButton"] = "recommendation_addButton";
})(RecommendationAttributes || (RecommendationAttributes = {}));
// OutwardReferral attributes
export var OutwardReferralAttributes;
(function (OutwardReferralAttributes) {
    OutwardReferralAttributes["Name"] = "outwardReferral_name";
    OutwardReferralAttributes["AuthorSelect"] = "outwardReferral_authorSelect";
    OutwardReferralAttributes["LegalEntitySelect"] = "outwardReferral_organizationSelect";
    OutwardReferralAttributes["LegalEntityAgreement"] = "outwardReferral_organizationAgreement";
    OutwardReferralAttributes["LegalEntityAddress"] = "outwardReferral_organizationAddress";
    OutwardReferralAttributes["LegalEntityPhone"] = "outwardReferral_organizationPhone";
    OutwardReferralAttributes["LegalEntitySite"] = "outwardReferral_organizationSite";
    OutwardReferralAttributes["Doctor"] = "outwardReferral_doctor";
    OutwardReferralAttributes["CostFrom"] = "outwardReferral_costFrom";
    OutwardReferralAttributes["CostTo"] = "outwardReferral_costTo";
    OutwardReferralAttributes["Comment"] = "outwardReferral_comment";
    OutwardReferralAttributes["ExecuteButton"] = "outwardReferral_executeButton";
    OutwardReferralAttributes["CreateRemoveButtons"] = "outwardReferral_createRemoveButtons";
})(OutwardReferralAttributes || (OutwardReferralAttributes = {}));
// Drug attributes
export var DrugAttributes;
(function (DrugAttributes) {
    DrugAttributes["ActiveSubstanceSelect"] = "drug_activeSubstanceSelect";
    DrugAttributes["TradeNameSelect"] = "drug_tradeNameSelect";
    DrugAttributes["FrequencyIfReception"] = "drug_frequencyIfReception";
    DrugAttributes["Directions"] = "drug_directions";
    DrugAttributes["StartDate"] = "drug_startDate";
    DrugAttributes["EndDate"] = "drug_endDate";
    DrugAttributes["ActionButton"] = "drug_favorite_actionButton";
    DrugAttributes["CreateFavoriteButton"] = "drug_favorite_createButton";
    DrugAttributes["SaveFavoriteButton"] = "drug_favorite_saveButton";
    DrugAttributes["CancelCreateFavoriteButton"] = "drug_favorite_cancelCreate";
    DrugAttributes["FavoriteName"] = "drug_favorite_name";
    DrugAttributes["FavoriteGroupName"] = "drug_favorite_groupName";
    DrugAttributes["FavoriteCancelConform"] = "drug_favorite_cancelConform";
    DrugAttributes["AddButton"] = "drug_addButton";
    DrugAttributes["AddSelectedButton"] = "drug_favorite_addSelectedButton";
    DrugAttributes["RemoveFavoriteButton"] = "drug_favorite_removeButton";
    DrugAttributes["Checked"] = "drug_favorite_checked";
})(DrugAttributes || (DrugAttributes = {}));
// Allergy attributes
export var AllergyAttributes;
(function (AllergyAttributes) {
    AllergyAttributes["Allergen"] = "allergy_allergen";
    AllergyAttributes["AllergyReactions"] = "allergy_allergyReactions";
    AllergyAttributes["SaveButton"] = "allergy_saveButton";
    AllergyAttributes["CancelButton"] = "allergy_cancelButton";
    AllergyAttributes["RemoveButton"] = "allergy_removeButton";
    AllergyAttributes["AddButton"] = "allergy_addButton";
    AllergyAttributes["AddDrugButton"] = "allergy_addDrugButton";
})(AllergyAttributes || (AllergyAttributes = {}));
export var UsedMedicationsAttributes;
(function (UsedMedicationsAttributes) {
    UsedMedicationsAttributes["Allergen"] = "usedMedications_allergen";
    UsedMedicationsAttributes["AllergyReactions"] = "usedMedications_allergyReactions";
    UsedMedicationsAttributes["SaveButton"] = "usedMedications_saveButton";
    UsedMedicationsAttributes["FrequencyIfReception"] = "usedMedications_frequencyIfReception";
    UsedMedicationsAttributes["CancelButton"] = "usedMedications_cancelButton";
    UsedMedicationsAttributes["RemoveButton"] = "usedMedications_removeButton";
    UsedMedicationsAttributes["AddButton"] = "usedMedications_addButton";
    UsedMedicationsAttributes["AddDrugButton"] = "usedMedications_addDrugButton";
    UsedMedicationsAttributes["ResetButton"] = "usedMedications_resetButton";
})(UsedMedicationsAttributes || (UsedMedicationsAttributes = {}));
// Diagnosis attributes
export var DiagnosisAttributes;
(function (DiagnosisAttributes) {
    DiagnosisAttributes["ClinicalDiagnosis"] = "diagnosis_clinicalDiagnosis";
    DiagnosisAttributes["IcdSelect"] = "diagnosis_icdSelect";
    DiagnosisAttributes["MainButton"] = "diagnosis_mainButton";
    DiagnosisAttributes["CancelButton"] = "diagnosis_cancelButton";
    DiagnosisAttributes["AddToFavoriteButton"] = "diagnosis_addToFavoriteButton";
    DiagnosisAttributes["AddButton"] = "diagnosis_addButton";
    DiagnosisAttributes["RemoveButton"] = "diagnosis_removeButton";
    DiagnosisAttributes["EditButton"] = "diagnosis_editButton";
    DiagnosisAttributes["Search"] = "diagnosis_search";
})(DiagnosisAttributes || (DiagnosisAttributes = {}));
// User page attributes
export var UserPageAttributes;
(function (UserPageAttributes) {
    UserPageAttributes["ProfileInput"] = "userPage_profileInput";
    UserPageAttributes["ProfileCheckbox"] = "userPage_profileCheckbox";
    UserPageAttributes["EditConfirm"] = "userPage_editComfitm";
    UserPageAttributes["RedirectPhone"] = "userPage_redirectPhone";
    UserPageAttributes["AddRedirectPhoneButton"] = "userPage_addRedirectPhoneButton";
    UserPageAttributes["RemoveRedirectPhoneButton"] = "userPage_removeRedirectPhoneButton";
    UserPageAttributes["ChangePasswordButton"] = "userPage_changePasswordButton";
    UserPageAttributes["ChangePasswordConfirmButton"] = "userPage_changePasswordConfirmButton";
    UserPageAttributes["LoginAsButton"] = "userPage_loginAsButton";
    UserPageAttributes["RoleSelect"] = "userPage_roleSelect";
    UserPageAttributes["ShortPhoneNumber"] = "userPage_shortPhoneNumber";
    UserPageAttributes["StartOfCareer"] = "userPage_startOfCareer";
    UserPageAttributes["LanguageSelect"] = "userPage_";
    UserPageAttributes["SaveButton"] = "userPage_saveButton";
    UserPageAttributes["CancelButton"] = "userPage_cancelButton";
    UserPageAttributes["EntryTypeSelect"] = "userPage_entryTypeSelect";
    UserPageAttributes["CreteUserButton"] = "userList_createUserButton";
    UserPageAttributes["RedirectEnabled"] = "userList_redirectEnabled";
    UserPageAttributes["TabBar"] = "userPage_tabBar";
    UserPageAttributes["Tab"] = "userPage_tabBar";
})(UserPageAttributes || (UserPageAttributes = {}));
//  Template page attributes
export var TemplatePageAttributes;
(function (TemplatePageAttributes) {
    TemplatePageAttributes["SearchInput"] = "templatePage_searchInput";
    TemplatePageAttributes["AddButton"] = "templatePage_addButton";
    TemplatePageAttributes["FilterItem"] = "templatePage_filterItem";
})(TemplatePageAttributes || (TemplatePageAttributes = {}));
//  Dictionary page attributes
export var DictionaryPageAttributes;
(function (DictionaryPageAttributes) {
    DictionaryPageAttributes["Title"] = "dictionaryPage_title";
    DictionaryPageAttributes["TitleTranslation"] = "dictionaryPage_titleTranslation";
    DictionaryPageAttributes["Value"] = "dictionaryPage_value";
    DictionaryPageAttributes["Synonyms"] = "dictionaryPage_synonyms";
    DictionaryPageAttributes["ConfirmationIcons"] = "dictionaryPage_confirmationIcons";
    DictionaryPageAttributes["EditRemoveIcons"] = "dictionaryPage_editRemoveIcons";
    DictionaryPageAttributes["RestoreIcon"] = "dictionaryPage_restoreIcon";
})(DictionaryPageAttributes || (DictionaryPageAttributes = {}));
//  EditEntryTypePage attributes
export var EditEntryTypePageAttributes;
(function (EditEntryTypePageAttributes) {
    EditEntryTypePageAttributes["Title"] = "editEntryTypePage_title";
    EditEntryTypePageAttributes["Collapsible"] = "editEntryTypePage_collapsible";
    EditEntryTypePageAttributes["OnlyFemale"] = "editEntryTypePage_onlyFemale";
    EditEntryTypePageAttributes["Order"] = "editEntryTypePage_order";
    EditEntryTypePageAttributes["TypeSelect"] = "editEntryTypePage_typeSelect";
    EditEntryTypePageAttributes["DefaultType"] = "editEntryTypePage_defaultType";
    EditEntryTypePageAttributes["TypeMultiSelect"] = "editEntryTypePage_typeMultiSelect";
    EditEntryTypePageAttributes["IsNested"] = "editEntryTypePage_isNested";
    EditEntryTypePageAttributes["EditEntryTypeServiceButton"] = "editEntryTypePage_editEntryTypeServiceButton";
    EditEntryTypePageAttributes["SystemName"] = "editEntryTypePage_systemName";
    EditEntryTypePageAttributes["WidthSelect"] = "editEntryTypePage_widthSelect";
    EditEntryTypePageAttributes["BlockAlignSelect"] = "editEntryTypePage_blockAlignSelect";
    EditEntryTypePageAttributes["ServiceSelect"] = "editEntryTypePage_serviceSelect";
    EditEntryTypePageAttributes["DateMode"] = "editEntryTypePage_dateMode";
    EditEntryTypePageAttributes["DictionarySelect"] = "editEntryTypePag_dictionarySelect";
    EditEntryTypePageAttributes["CopyFieldButton"] = "editEntryTypePage_copyFieldButton";
    EditEntryTypePageAttributes["Global"] = "editEntryTypePage_global";
    EditEntryTypePageAttributes["Name"] = "editEntryTypePage_name";
    EditEntryTypePageAttributes["IsHide"] = "editEntryTypePage_isHide";
    EditEntryTypePageAttributes["DefaultValue"] = "editEntryTypePage_defaultValue";
    EditEntryTypePageAttributes["Dictionary"] = "editEntryTypePage_dictionary";
    EditEntryTypePageAttributes["Label"] = "editEntryTypePage_label";
    EditEntryTypePageAttributes["Mask"] = "editEntryTypePage_mask";
    EditEntryTypePageAttributes["Value"] = "editEntryTypePage_value";
    EditEntryTypePageAttributes["Formula"] = "editEntryTypePage_formula";
    EditEntryTypePageAttributes["WithComment"] = "editEntryTypePage_withComment";
    EditEntryTypePageAttributes["Placeholder"] = "editEntryTypePage_placeholder";
    EditEntryTypePageAttributes["SearchBlock"] = "editEntryTypePage_searchBlock";
    EditEntryTypePageAttributes["AddEntryTypeButton"] = "editEntryTypePage_addEntryTypeButton";
    EditEntryTypePageAttributes["AddBlockButton"] = "editEntryTypePage_addBlockButton";
    EditEntryTypePageAttributes["CreateCopyButton"] = "editEntryTypePage_createCopyButton";
})(EditEntryTypePageAttributes || (EditEntryTypePageAttributes = {}));
//  Schedule page attributes
export var SchedulePageAttributes;
(function (SchedulePageAttributes) {
    SchedulePageAttributes["ReservationCardLeftLine"] = "schedule_reservationCard_leftLine";
    SchedulePageAttributes["ReservationCardSecondLeftLine"] = "schedule_reservationCard_secondLeftLine";
    SchedulePageAttributes["ReservationCardRightLine"] = "schedule_reservationCard_rightLine";
    SchedulePageAttributes["ReservationCardSecondRightLine"] = "schedule_reservationCard_secondRightLine";
    SchedulePageAttributes["ReservationFormPatientSelect"] = "schedule_reservationForm_patientSelect";
    SchedulePageAttributes["RemovePatientButton"] = "schedule_removePatientButton";
    SchedulePageAttributes["ReservationFormPhone"] = "schedule_reservationForm_phone";
    SchedulePageAttributes["ReservationFormServices"] = "schedule_reservationForm_services";
    SchedulePageAttributes["ReservationFormPrice"] = "schedule_reservationForm_price";
    SchedulePageAttributes["ReservationFormDoNotNotify"] = "schedule_reservationForm_doNotNotify";
    SchedulePageAttributes["ReservationFormIgnoreCancellationPenalty"] = "schedule_reservationForm_ignoreCancellationPenalty";
    SchedulePageAttributes["ReservationFormIgnoreAgeLimit"] = "schedule_reservationForm_ignoreAgeLimit";
    SchedulePageAttributes["ReservationFormDisablePaymentCardChecking"] = "schedule_reservationForm_disablePaymentCardChecking";
    SchedulePageAttributes["ReservationFormReferral"] = "schedule_reservationForm_referral";
    SchedulePageAttributes["ReservationFormRemoveReferralButton"] = "schedule_reservationForm_removeReferralButton";
    SchedulePageAttributes["ReservationFormStartTime"] = "schedule_reservationForm_startTime";
    SchedulePageAttributes["ReservationFormDuration"] = "schedule_reservationForm_duration";
    SchedulePageAttributes["ReservationFormComment"] = "schedule_reservationForm_comment";
    SchedulePageAttributes["ReservationFormSave"] = "schedule_reservationForm_save";
    SchedulePageAttributes["ReservationFormCancel"] = "schedule_reservationForm_cancel";
    SchedulePageAttributes["ReservationFormRemove"] = "schedule_reservationForm_remove";
    SchedulePageAttributes["ChannelSelect"] = "schedule_reservationForm_channelSelect";
    SchedulePageAttributes["ReservationFormNewReservationTab"] = "schedule_reservationForm_newReservationTab";
    SchedulePageAttributes["ReservationFormFillerTab"] = "schedule_reservationForm_fillerTab";
    SchedulePageAttributes["ReservationFormReservationTab"] = "schedule_reservationForm_reservationTab";
    SchedulePageAttributes["ReservationFormHistoryTab"] = "schedule_reservationForm_historyTab";
    SchedulePageAttributes["ReservationHistoryCard"] = "schedule_reservationForm_historyCard";
    SchedulePageAttributes["TypeSelect"] = "schedule_reservationForm_channelSelect";
    SchedulePageAttributes["FullDaySwitch"] = "schedule_reservationForm_channelSelect";
    SchedulePageAttributes["ReservationDetail"] = "schedule_reservationDetail";
    SchedulePageAttributes["CreateEntryButton"] = "schedule_reservationDetail_createEntry";
    SchedulePageAttributes["PatientCameButton"] = "schedule_reservationDetail_patientCameButton";
    SchedulePageAttributes["MergeEhrsButton"] = "schedule_reservationDetail_mergeEhrsButton";
    SchedulePageAttributes["CopyZoomButton"] = "schedule_reservationDetail_copyZoomButton";
    SchedulePageAttributes["RightMenuCopyZoomButton"] = "schedule_reservationDetail_rightMenuCopyZoomButton";
    SchedulePageAttributes["SendInformedConsentButton"] = "schedule_reservationDetail_sendInformedConsentButton";
    SchedulePageAttributes["InformedConsentSendedButton"] = "schedule_reservationDetail_informedConsentSendedButton";
    SchedulePageAttributes["PrintInformedConsentButton"] = "schedule_reservationDetail_printInformedConsentButton";
    SchedulePageAttributes["EhrComment"] = "schedule_reservationDetail_ehrComment";
    SchedulePageAttributes["ReservationComment"] = "schedule_reservationDetail_reservationComment";
    SchedulePageAttributes["LegendButton"] = "schedule_leftMenu_legendButton";
    SchedulePageAttributes["ApplyFiltersButton"] = "schedule_leftMenu_applyFilters";
    SchedulePageAttributes["ResetFiltersButton"] = "schedule_leftMenu_resetFilters";
    SchedulePageAttributes["ShowCancelled"] = "schedulePage_showCanceledReservation";
    SchedulePageAttributes["ShowNotWorking"] = "schedulePage_showNotWorking";
    SchedulePageAttributes["ChangeConfidentialMode"] = "schedulePage_changeConfidentialMode";
    SchedulePageAttributes["Sorting"] = "schedule_sorting";
    SchedulePageAttributes["LeftMenuDayWeekSelect"] = "schedule_leftMenu_dayWeekSelect";
    SchedulePageAttributes["OrganizationFilter"] = "schedulePage_organizationFilter";
    SchedulePageAttributes["UserFilter"] = "schedulePage_userFilter";
    SchedulePageAttributes["SpecialityFilter"] = "schedulePage_specialityFilter";
    SchedulePageAttributes["ServiceFilter"] = "schedulePage_serviceFilter";
    SchedulePageAttributes["PatientFilter"] = "schedulePage_patientFilter";
    SchedulePageAttributes["OfficeFilter"] = "schedulePage_officeFilter";
    SchedulePageAttributes["DeviceFilter"] = "schedulePage_deviceFilter";
})(SchedulePageAttributes || (SchedulePageAttributes = {}));
export var ScheduleV2PageAttributes;
(function (ScheduleV2PageAttributes) {
    ScheduleV2PageAttributes["OrganizationFilter"] = "scheduleV2Page_organizationFilter";
    ScheduleV2PageAttributes["DoctorFilter"] = "scheduleV2Page_doctorFilter";
    ScheduleV2PageAttributes["SpecialtyFilter"] = "scheduleV2Page_specialtyFilter";
    ScheduleV2PageAttributes["ServiceFilter"] = "scheduleV2Page_serviceFilter";
    ScheduleV2PageAttributes["PatientFilter"] = "scheduleV2Page_patientFilter";
    ScheduleV2PageAttributes["OfficeFilter"] = "scheduleV2Page_officeFilter";
    ScheduleV2PageAttributes["DeviceFilter"] = "scheduleV2Page_deviceFilter";
    ScheduleV2PageAttributes["DeviceGridColumn"] = "scheduleV2Page_deviceGridColumn";
    ScheduleV2PageAttributes["Sorting"] = "scheduleV2Page_sorting";
    ScheduleV2PageAttributes["ConfidentialModeSwitch"] = "scheduleV2Page_confidentialModeSwitch";
    ScheduleV2PageAttributes["CancelledReservationsSwitch"] = "scheduleV2Page_cancelledReservationsSwitch";
    ScheduleV2PageAttributes["NotWorkingSwitch"] = "scheduleV2Page_notWorkingSwitch";
    ScheduleV2PageAttributes["ResetFiltersButton"] = "scheduleV2Page_resetFilters";
    ScheduleV2PageAttributes["ReservationCreateForm"] = "scheduleV2Page_reservationCreateForm";
    ScheduleV2PageAttributes["ReservationFormTabs"] = "scheduleV2Page_reservationFormTabs";
    ScheduleV2PageAttributes["ReservationFormReservationTab"] = "scheduleV2Page_reservationFormReservationTab";
    ScheduleV2PageAttributes["ReservationFormHistoryTab"] = "scheduleV2Page_reservationFormHistoryTab";
    ScheduleV2PageAttributes["ReservationTypeSelect"] = "scheduleV2Page_reservationTypeSelect";
    ScheduleV2PageAttributes["TimeBlockRuleTitleInput"] = "scheduleV2Page_timeBlockRuleTitleInput";
    ScheduleV2PageAttributes["ReservationPatientSelect"] = "scheduleV2Page_reservationPatientSelect";
    ScheduleV2PageAttributes["ReservationPhoneInput"] = "scheduleV2Page_reservationPhoneInput";
    ScheduleV2PageAttributes["ReservationChannelSelect"] = "scheduleV2Page_reservationChannelSelect";
    ScheduleV2PageAttributes["ReservationCopyMeetingLinkButton"] = "scheduleV2Page_reservationCopyMeetingLink";
    ScheduleV2PageAttributes["ReservationCommentInput"] = "scheduleV2Page_reservationCommentInput";
    ScheduleV2PageAttributes["ReservationDoNotNotifyCheckbox"] = "scheduleV2Page_reservationDoNotNotify";
    ScheduleV2PageAttributes["ReservationIgnoreCancellationPenaltyCheckbox"] = "scheduleV2Page_reservationIgnoreCancellationPenalty";
    ScheduleV2PageAttributes["ReservationIgnoreAgeLimitCheckbox"] = "scheduleV2Page_reservationIgnoreAgeLimit";
    ScheduleV2PageAttributes["ReservationDoctorSelect"] = "scheduleV2Page_reservationDoctorSelect";
    ScheduleV2PageAttributes["ReservationOfficeSelect"] = "scheduleV2Page_reservationOfficeSelect";
    ScheduleV2PageAttributes["ReservationDeviceInput"] = "scheduleV2Page_reservationDeviceInput";
    ScheduleV2PageAttributes["ReservationStartDateInput"] = "scheduleV2Page_reservationStartDateInput";
    ScheduleV2PageAttributes["ReservationStartTimeInput"] = "scheduleV2Page_reservationStartTimeInput";
    ScheduleV2PageAttributes["ReservationDurationInput"] = "scheduleV2Page_reservationDurationInput";
    ScheduleV2PageAttributes["ReservationFillTimeButton"] = "scheduleV2Page_reservationFillTime";
    ScheduleV2PageAttributes["ReservationReferralsBlock"] = "scheduleV2Page_reservationReferrals";
    /** Префикс: полный атрибут чекбокса — `${ReservationReferralCheckbox}_${referralId}` */
    ScheduleV2PageAttributes["ReservationReferralCheckbox"] = "scheduleV2Page_reservationReferral";
    ScheduleV2PageAttributes["ReservationReferralsNoTimeNote"] = "scheduleV2Page_reservationReferralsNoTimeNote";
    ScheduleV2PageAttributes["ReservationDeleteButton"] = "scheduleV2Page_reservationDelete";
    ScheduleV2PageAttributes["ReservationCreateButton"] = "scheduleV2Page_reservationCreate";
    ScheduleV2PageAttributes["ReservationCancelButton"] = "scheduleV2Page_reservationCancel";
    ScheduleV2PageAttributes["LegendButton"] = "scheduleV2Page_legendButton";
    ScheduleV2PageAttributes["Grid"] = "scheduleV2Grid";
    /** Префикс: полный атрибут колонки — `${GridColumn}_${columnId}` */
    ScheduleV2PageAttributes["GridColumn"] = "scheduleV2Grid_column";
    /** Префикс: полный id карточки — `${GridCard}_${itemId}` */
    ScheduleV2PageAttributes["GridCard"] = "scheduleV2Grid_card";
    ScheduleV2PageAttributes["GridCardDetail"] = "scheduleV2Grid_cardDetail";
    ScheduleV2PageAttributes["GridCardReferralIcon"] = "scheduleV2Grid_cardReferralIcon";
    ScheduleV2PageAttributes["GridEmptyResult"] = "scheduleV2Grid_empty";
})(ScheduleV2PageAttributes || (ScheduleV2PageAttributes = {}));
//  Plan page attributes
export var PlanPageAttributes;
(function (PlanPageAttributes) {
    PlanPageAttributes["Name"] = "planPage_name";
    PlanPageAttributes["PlanTypeSelect"] = "planPage_planType";
    PlanPageAttributes["PayerTypeSelect"] = "planPage_payerTypeSelect";
    PlanPageAttributes["ContractorSelect"] = "planPage_contractorSelect";
    PlanPageAttributes["LegalEntitySelect"] = "planPage_organizationSelect";
    PlanPageAttributes["UserSelect"] = "planPage_userSelect";
    PlanPageAttributes["StartDate"] = "planPage_startDate";
    PlanPageAttributes["VersionStartDate"] = "planPage_versionStartDate";
    PlanPageAttributes["EndDate"] = "planPage_endDate";
    PlanPageAttributes["DurationSelect"] = "planPage_durationSelect";
    PlanPageAttributes["Conditions"] = "planPage_conditions";
    PlanPageAttributes["Share"] = "planPage_share";
    PlanPageAttributes["Discount"] = "planPage_discount";
    PlanPageAttributes["MoneyLimit"] = "planPage_money-limit";
    PlanPageAttributes["Cost"] = "planPage_cost";
    PlanPageAttributes["ExcludeServicesSelect"] = "planPage_excludeServicesSelect";
    PlanPageAttributes["ExcludeGroupsSelect"] = "planPage_excludeGroupsSelect";
    PlanPageAttributes["PlanServiceSelect"] = "planPage_planServiceSelect";
    PlanPageAttributes["MinAgeInput"] = "planPage_minAgeInput";
    PlanPageAttributes["MaxAgeInput"] = "planPage_maxAgeInput";
    PlanPageAttributes["SaveButton"] = "planPage_saveButton";
    PlanPageAttributes["CancelButton"] = "planPage_cancelButton";
    PlanPageAttributes["LoadIncludedServicesButton"] = "planPage_loadIncludedServicesButton";
    PlanPageAttributes["CreatePlanButton"] = "planPage_createPlanButton";
})(PlanPageAttributes || (PlanPageAttributes = {}));
// Patient list page attributes
export var PatientListPageAttributes;
(function (PatientListPageAttributes) {
    PatientListPageAttributes["SearchInput"] = "patientListPage_searchInput";
    PatientListPageAttributes["SearchButton"] = "patientListPage_searchButton";
    PatientListPageAttributes["CreateEhrButton"] = "patientListPage_createEhrButton";
    PatientListPageAttributes["SelectListButton"] = "patientListPage_selectListButton";
    PatientListPageAttributes["MergeButton"] = "patientListPage_mergeButton";
    PatientListPageAttributes["ReturnToPatientButton"] = "patientListPage_returnToPatientButton";
})(PatientListPageAttributes || (PatientListPageAttributes = {}));
//  Billing attributes
export var BillingAttributes;
(function (BillingAttributes) {
    BillingAttributes["AmountToPay"] = "billing_amountToPay";
    BillingAttributes["RefundButton"] = "billing_refundButton";
    BillingAttributes["InProcessButton"] = "billing_inProcessButton";
    BillingAttributes["RefundToPersonalAccountButton"] = "billing_refundToPersonalAccountButton";
    BillingAttributes["RefundMethodReceiptSwitch"] = "billing_refundMethodReceiptSwitch";
    BillingAttributes["CancelButton"] = "billing_cancelButton";
    BillingAttributes["PaymentUrlPhone"] = "billing_paymentUrlPhone";
    BillingAttributes["SendPaymentUrlButton"] = "billing_sendPaymentUrlButton";
    BillingAttributes["PayButton"] = "billing_payButton";
    BillingAttributes["Minuend"] = "billing_minuend";
    BillingAttributes["Subtrahend"] = "billing_subtrahend";
    BillingAttributes["Remainder"] = "billing_remainder";
    BillingAttributes["ExecutorSelect"] = "billing_executorSelect";
    BillingAttributes["OrganizationSelect"] = "billing_organizationSelect";
    BillingAttributes["DateFrom"] = "billing_dateFrom";
    BillingAttributes["SearchServiceId"] = "billing_searchServiceId";
    BillingAttributes["SearchEhr"] = "billing_searchEhr";
    BillingAttributes["ApplyFilters"] = "billing_applyFilters";
    BillingAttributes["PrintActButton"] = "billing_printActButton";
    BillingAttributes["MerchantAcquiringCashless"] = "billing_merchantAcquiringCashless";
    BillingAttributes["InternetAcquiringCashless"] = "billing_internetAcquiringCashless";
    BillingAttributes["TabsUnpaid"] = "billingPage_tabs_unpaid";
    BillingAttributes["TabsInProcess"] = "billingPage_tabs_in-process";
    BillingAttributes["TabsPayments"] = "billingPage_tabs_payments";
    BillingAttributes["TabsPaymentsByLegalEntity"] = "billingPage_tabs_paymentsByLegalEntity";
    BillingAttributes["TabsReports"] = "billingPage_tabs_reports";
    BillingAttributes["TabsUnpaidReports"] = "billingPage_tabs_unpaidReports";
    BillingAttributes["TabsErrorRenderedService"] = "billingPage_tabs_errorRenderedService";
    BillingAttributes["TabsRenderedServices"] = "billingPage_tabs_renderedServices";
    BillingAttributes["TabsReconciliation"] = "billingPage_tabs_reconciliation";
    BillingAttributes["TabsPaymentsReport"] = "billingPage_tabs_paymentsReport";
    BillingAttributes["IsAllChecked"] = "billingPage_isAllChecked";
    BillingAttributes["RowCheck"] = "billingPage_rowCheck";
    BillingAttributes["Refund"] = "billing_refund";
    BillingAttributes["IssueReceipt"] = "billing_issueReceipt";
})(BillingAttributes || (BillingAttributes = {}));
export var UnpaidPage;
(function (UnpaidPage) {
    UnpaidPage["UnpaidTable"] = "unpaidPage_unpaidTable";
})(UnpaidPage || (UnpaidPage = {}));
export var PaymentsPage;
(function (PaymentsPage) {
    PaymentsPage["PaymentsTable"] = "paymentsPage_paymentsTable";
})(PaymentsPage || (PaymentsPage = {}));
// Price page attributes
export var PricePageAttributes;
(function (PricePageAttributes) {
    PricePageAttributes["ServiceSelect"] = "pricePage_serviceSelect";
    PricePageAttributes["CompositeServiceSelect"] = "pricePage_compositeServiceSelect";
    PricePageAttributes["LegalEntitiesSelect"] = "pricePage_legalEntitiesSelect";
    PricePageAttributes["ScheduledOnDate"] = "pricePage_scheduledOnDate";
    PricePageAttributes["SaveButton"] = "pricePage_saveButton";
    PricePageAttributes["CancelButton"] = "pricePage_cancelButton";
    PricePageAttributes["RemoveButton"] = "pricePage_removeButton";
    PricePageAttributes["LoadCSV"] = "pricePage_loadCSV";
    PricePageAttributes["UpdatePrice"] = "pricePage_updatePrice";
    PricePageAttributes["StatusCheckbox"] = "pricePage_statusCheckbox";
})(PricePageAttributes || (PricePageAttributes = {}));
export var PricePageTableAttributes;
(function (PricePageTableAttributes) {
    PricePageTableAttributes["AddButton"] = "pricePageTable_addButton";
    PricePageTableAttributes["SearchButton"] = "pricePageTable_searchButton";
    PricePageTableAttributes["SearchInput"] = "pricePageTable_searchInput";
    PricePageTableAttributes["FilterServiceId"] = "pricePageTable_filterServiceId";
    PricePageTableAttributes["FilterLegalEntityIds"] = "pricePageTable_filterLegalEntityIds";
    PricePageTableAttributes["FilterOrganizationId"] = "pricePageTable_filterOrganizationId";
    PricePageTableAttributes["FilterUserId"] = "pricePageTable_filterUserId";
    PricePageTableAttributes["FilterContractorId"] = "pricePageTable_filterContractorId";
    PricePageTableAttributes["FilterStatus"] = "pricePageTable_filterStatus";
    PricePageTableAttributes["MoveToArchiveAction"] = "pricePageTable_moveToArchiveAction";
    PricePageTableAttributes["MultiEditAction"] = "pricePageTable_multiEditAction";
    PricePageTableAttributes["RowEditButtonActionNew"] = "pricePageTable_rowEditButtonActionNew";
    PricePageTableAttributes["RowEditButtonActionEdit"] = "pricePageTable_rowEditButtonActionEdit";
    PricePageTableAttributes["RowEditButtonActionArchive"] = "pricePageTable_rowEditButtonActionArchive";
    PricePageTableAttributes["RowEditButtonActionDelete"] = "pricePageTable_rowEditButtonActionDelete";
    // FilterSearchInput = 'pricePageTable_***_search',
    // FilterCheckbox = 'pricePageTable_***_checkbox',
    // FilterApply = 'pricePageTable_***_apply',
    // FilterReset = 'pricePageTable_***_reset',
})(PricePageTableAttributes || (PricePageTableAttributes = {}));
export var PricePageTableCreationMenu;
(function (PricePageTableCreationMenu) {
    PricePageTableCreationMenu["Button"] = "pricePageTableCreationMenu_button";
    PricePageTableCreationMenu["SaveButton"] = "pricePageTableCreationMenu_buttonSave";
    PricePageTableCreationMenu["CancelButton"] = "pricePageTableCreationMenu_buttonCancel";
})(PricePageTableCreationMenu || (PricePageTableCreationMenu = {}));
// Ehr page attributes
export var EhrPageAttributes;
(function (EhrPageAttributes) {
    EhrPageAttributes["RepresentativeSelect"] = "profilePage_representativeSelect";
    EhrPageAttributes["EditRepresentative"] = "profilePage_representative_edit";
    EhrPageAttributes["AddRepresentative"] = "profilePage_addRepresentative";
    EhrPageAttributes["RemoveRepresentative"] = "profilePage_representative_remove";
    EhrPageAttributes["AssignRepresentativeButton"] = "profilePage_representative_assign";
    EhrPageAttributes["CreateRepresentativeButton"] = "profilePage_representative_createCard";
    EhrPageAttributes["ConfirmRepresentativeButton"] = "profilePage_representative_confirm";
    EhrPageAttributes["PrimaryChannelSelect"] = "profilePage_primaryChannelSelect";
    EhrPageAttributes["LegalDocConfirm"] = "profilePage_legalDocConfirm";
    EhrPageAttributes["ExtraDocConfirm"] = "profilePage_extraDocConfirm";
    EhrPageAttributes["IdentityDocDate"] = "profilePage_identityDocDate";
    EhrPageAttributes["IdentityDocType"] = "profilePage_identityDocType";
    EhrPageAttributes["InternationalIdIssueDate"] = "profilePage_internationalIdIssueDate";
    EhrPageAttributes["InternationalIdExpiryDate"] = "profilePage_internationalIdExpiryDate";
    EhrPageAttributes["TypeOfWorkSelect"] = "profilePage_typeOfWorkSelect";
    EhrPageAttributes["HeaderButtons"] = "profilePage_headerButtons";
    EhrPageAttributes["CreateMedicalCaseButton"] = "ehrPage_createMedicalCaseButton";
    EhrPageAttributes["SendContacts"] = "ehrPage_sendContacts";
    EhrPageAttributes["AddFile"] = "profilePage_addFile";
    EhrPageAttributes["ContactPersonLastName"] = "profilePage_contactPerson_lastName";
    EhrPageAttributes["ContactPersonFirstName"] = "profilePage_contactPerson_firstName";
    EhrPageAttributes["ContactPersonPatronymic"] = "profilePage_contactPerson_patronymic";
    EhrPageAttributes["ContactPersonPhone"] = "profilePage_contactPerson_phone";
    EhrPageAttributes["ContactPersonCancel"] = "profilePage_contactPerson_cancel";
    EhrPageAttributes["ContactPersonRemove"] = "profilePage_contactPerson_remove";
    EhrPageAttributes["ContactPersonEdit"] = "profilePage_contactPerson_edit";
    EhrPageAttributes["Sex"] = "profilePage_sex";
    EhrPageAttributes["PersonalAccountCreated"] = "profilePage_personalAccountCreated";
    EhrPageAttributes["DocumentsSigned"] = "profilePage_documentsSigned";
    EhrPageAttributes["SendRegistrationUrlButton"] = "profilePage_sendRegistrationUrlButton";
    EhrPageAttributes["SendConfirmationCodeButton"] = "profilePage_sendConfirmationCodeButton";
    EhrPageAttributes["ContactPersonAdd"] = "profilePage_contactPerson_add";
    EhrPageAttributes["ReplenishButton"] = "profilePage_replenishButton";
    EhrPageAttributes["WriteOffButton"] = "profilePage_debitButton";
    EhrPageAttributes["PrintButton"] = "profilePage_replenishButton";
    EhrPageAttributes["PrintTitleButton"] = "profilePage_replenishButton";
    EhrPageAttributes["ReferralStatusFilter"] = "profilePage_referralStatusFilter";
    EhrPageAttributes["MyEntries"] = "profilePage_myEntries";
    EhrPageAttributes["PrintInformedConsent"] = "profilePage_printInformedConsent";
    EhrPageAttributes["RemoveNotExistEntries"] = "profilePage_removeNotExistEntries";
    EhrPageAttributes["RepresentativePopupConfirm"] = "profilePage_representativePopupConfirm";
    EhrPageAttributes["RepresentativePopupCancel"] = "profilePage_representativePopupCancel";
})(EhrPageAttributes || (EhrPageAttributes = {}));
export var PreOperationPage;
(function (PreOperationPage) {
    PreOperationPage["PreOperationTable"] = "preOperationPage_preOperationTable";
})(PreOperationPage || (PreOperationPage = {}));
// Lab page attributes
export var LabPageAttributes;
(function (LabPageAttributes) {
    LabPageAttributes["FromFilter"] = "labPage_fromFilter";
    LabPageAttributes["ToFilter"] = "labPage_toFilter";
    LabPageAttributes["OrganizationFilterSelect"] = "labPage_organizationFilterSelect";
    LabPageAttributes["OrganizationReportSelect"] = "labPage_organizationReportSelect";
    LabPageAttributes["LaboratoryFilterSelect"] = "labPage_laboratoryFilterSelect";
    LabPageAttributes["PrintOrderAll"] = "labPage_printAll";
    LabPageAttributes["OrderReadyButton"] = "labOrder_readyButton";
    LabPageAttributes["CancelOrderButton"] = "labPage_cancelOrderButton";
    LabPageAttributes["RegisterPageCancelButton"] = "registerPage_cancelButton";
    LabPageAttributes["RegisterPagePrintAllButton"] = "registerPage_printAllButton";
    LabPageAttributes["RegisterPageExitButton"] = "registerPage_exitButton";
    LabPageAttributes["RegisterPageSearchPatient"] = "registerPage_searchPatientInput";
    LabPageAttributes["RegisterPageSendButton"] = "registerPage_sendButton";
    LabPageAttributes["RegisterPageDetailButton"] = "registerPage_detailButton";
    LabPageAttributes["RegisterPageUpdateResultsButton"] = "registerPage_updateResultsButton";
    LabPageAttributes["LabReferralSearchInput"] = "labReferrals_patientSearchInput";
    LabPageAttributes["GetBiamateriaButton"] = "labReferrals_getBiomaterialButton";
    LabPageAttributes["TabsReferrals"] = "laboratoryPage_tabs_referrals";
    LabPageAttributes["TabsRegisters"] = "laboratoryPage_tabs_registers";
    LabPageAttributes["TabsOpen"] = "laboratoryPage_tabs_open";
    LabPageAttributes["TabsMyActive"] = "laboratoryPage_tabs_myActive";
    LabPageAttributes["TabsReports"] = "laboratoryPage_tabs_reports";
    LabPageAttributes["TabsVaccinationReports"] = "laboratoryPage_tabs_vaccinationReports";
    LabPageAttributes["TabsInvitroArmeniaReports"] = "laboratoryPage_tabs_invitro_armeniz";
    LabPageAttributes["TabsLaboratoryOrders"] = "laboratoryPage_tabs_laboratoryOrders";
    LabPageAttributes["IsAllChecked"] = "laboratoryPage_isAllChecked";
    LabPageAttributes["RowCheck"] = "laboratoryPage_rowCheck";
})(LabPageAttributes || (LabPageAttributes = {}));
// Dashboard page attributes
export var DashboardPageAttributes;
(function (DashboardPageAttributes) {
    DashboardPageAttributes["PatientFilterSelect"] = "dashboard_patientSelect";
    DashboardPageAttributes["CaseFilterSelect"] = "dashboard_caseFilterSelect";
    DashboardPageAttributes["ItemTypeFileterSelect"] = "dashboard_itemTypeFileterSelect";
    DashboardPageAttributes["ReferralFilterButton"] = "dashboard_referralFilterButton";
    DashboardPageAttributes["ResetFilterButton"] = "dashboard_resetFilterButton";
    DashboardPageAttributes["ApplyFilterButton"] = "dashboard_applyFilterButton";
    DashboardPageAttributes["DoctorSelect"] = "dashboard_doctorSelect";
    DashboardPageAttributes["MedicalCases"] = "dashboardPage_tabs_medicalCases";
    DashboardPageAttributes["MedicalCasesReport"] = "dashboardPage_tabs_medicalCasesReport";
    DashboardPageAttributes["Tasks"] = "dashboardPage_tabs_tasks";
    DashboardPageAttributes["Entries"] = "dashboardPage_tabs_entries";
    DashboardPageAttributes["TimelineReferrals"] = "dashboardPage_tabs_timelineReferrals";
    DashboardPageAttributes["Schedule"] = "dashboardPage_tabs_schedule";
    DashboardPageAttributes["TabsRenderedService"] = "dashboardPage_tabs_renderedService";
    DashboardPageAttributes["TabsRenderedServices"] = "dashboardPage_tabs_renderedServices";
    DashboardPageAttributes["TabsReferrals"] = "dashboardPage_tabs_referrals";
    DashboardPageAttributes["TabsMySubscriptions"] = "dashboardPage_tabs_mySubscriptions";
    DashboardPageAttributes["TabsRecurringSubscriptionsPage"] = "dashboardPage_tabs_recurringSubscriptionsPage";
    DashboardPageAttributes["TabsMyCovidSubscriptions"] = "dashboardPage_tabs_myCovidSubscriptions";
    DashboardPageAttributes["TabsAssistantDoctors"] = "dashboardPage_tabs_assistantDoctors";
    DashboardPageAttributes["TabsMyDoctor"] = "dashboardPage_tabs_myDoctor";
    DashboardPageAttributes["TabsMyDoctorRenderedServices"] = "dashboardPage_tabs_myDoctor_renderedServices";
    DashboardPageAttributes["TabsMyDoctorCovidSubscriptions"] = "dashboardPage_tabs_myDoctor_covidSubscriptions";
    DashboardPageAttributes["HideExpired"] = "dashboardPage_hideExpired";
    DashboardPageAttributes["HideExecutedTasks"] = "dashboardPage_hideExecutedTasks";
    DashboardPageAttributes["HideCancelledTasks"] = "dashboardPage_hideCancelledTasks";
    DashboardPageAttributes["OpenFiltersButton"] = "dashboardPage_openFiltersButton";
    DashboardPageAttributes["ReferralsStatusFilter"] = "dashboardPage_referralsStatusFilter";
    DashboardPageAttributes["ReferralsReferringDoctorFilter"] = "dashboardPage_referralsReferringDoctorFilter";
    DashboardPageAttributes["ReferralsEhrFilter"] = "dashboardPage_referralsEhrFilter";
    DashboardPageAttributes["ScheduleDetailsButtonSave"] = "dashboardPage_scheduleDetailsButton_save";
    DashboardPageAttributes["ScheduleDetailsPatientCame"] = "dashboardPage_scheduleDetailsPatientCame";
    DashboardPageAttributes["EpisodesSearchButton"] = "dashboardPage_episodes_searchButton";
})(DashboardPageAttributes || (DashboardPageAttributes = {}));
//  Create patient attributes
export var CreatePatientAttributes;
(function (CreatePatientAttributes) {
    CreatePatientAttributes["Age"] = "createPatient_age";
    CreatePatientAttributes["Sex"] = "createPatient_sex";
    CreatePatientAttributes["CreateButton"] = "createPatient_create";
    CreatePatientAttributes["CancelButton"] = "createPatient_cancel";
    CreatePatientAttributes["Confirmation"] = "createPatient_confirmation";
})(CreatePatientAttributes || (CreatePatientAttributes = {}));
//  Pregnancy attributes
export var PregnancyAttributes;
(function (PregnancyAttributes) {
    PregnancyAttributes["Year"] = "pregnancy_year";
    PregnancyAttributes["YearSelect"] = "pregnancy_yearSelect";
    PregnancyAttributes["GestationalAgeSelect"] = "pregnancy_gestationalAgeSelect";
})(PregnancyAttributes || (PregnancyAttributes = {}));
//  Treatment Plan attributes
export var TreatmentPlanAttributes;
(function (TreatmentPlanAttributes) {
    TreatmentPlanAttributes["EntryCreate"] = "treatmentPlan_entry_create";
    TreatmentPlanAttributes["ReferralCreate"] = "treatmentPlan_referral_create";
    TreatmentPlanAttributes["DrugCreate"] = "treatmentPlan_drug_create";
    TreatmentPlanAttributes["TaskCreate"] = "treatmentPlan_task_create";
    TreatmentPlanAttributes["RecommendationCreate"] = "treatmentPlan_recommendation_create";
    TreatmentPlanAttributes["OptionalReferralsCheckBox"] = "treatmentPlan_optionalReferrals_checkbox";
    TreatmentPlanAttributes["Author"] = "treatmentPlan_author";
})(TreatmentPlanAttributes || (TreatmentPlanAttributes = {}));
//  AuthUserPage attributes
export var AuthUserPageAttributes;
(function (AuthUserPageAttributes) {
    AuthUserPageAttributes["TabsProfile"] = "authUserPage_tabs_profile";
    AuthUserPageAttributes["TabsSiteProfile"] = "authUserPage_tabs_siteProfile";
    AuthUserPageAttributes["TabsScheduleSettings"] = "authUserPage_tabs_scheduleSettings";
    AuthUserPageAttributes["TabsActiveWorkTime"] = "authUserPage_tabs_activeWorkTime";
    AuthUserPageAttributes["TabsPrices"] = "authUserPage_tabs_prices";
    AuthUserPageAttributes["TabsPrice"] = "authUserPage_tabs_price";
    AuthUserPageAttributes["TabsUserSchedule"] = "authUserPage_tabs_userSchedule";
    AuthUserPageAttributes["TabsNotifications"] = "authUserPage_tabs_notifications";
    AuthUserPageAttributes["CreateWorkTimeButton"] = "authUserPage_createWorkTimeButton";
})(AuthUserPageAttributes || (AuthUserPageAttributes = {}));
//  ScheduleSettingsPage attributes
export var ScheduleSettingsPageAttributes;
(function (ScheduleSettingsPageAttributes) {
    ScheduleSettingsPageAttributes["ChatOnlyCheckbox"] = "scheduleSettingsPage_chatOnlyCheckbox";
    ScheduleSettingsPageAttributes["MultipleOfficesCheckbox"] = "scheduleSettingsPage_multipleOfficesCheckbox";
    ScheduleSettingsPageAttributes["MainOrganizationSelect"] = "scheduleSettingsPage_mainOrganizationSelect";
    ScheduleSettingsPageAttributes["UserOrganizations"] = "scheduleSettingsPage_userOrganizations";
})(ScheduleSettingsPageAttributes || (ScheduleSettingsPageAttributes = {}));
//  ValueTemplate attributes
export var ValueTemplateAttributes;
(function (ValueTemplateAttributes) {
    ValueTemplateAttributes["AllTemplateButton"] = "valueTemplate_allTemplateButton";
    ValueTemplateAttributes["FieldListButton"] = "valueTemplate_fieldListButton";
    ValueTemplateAttributes["GroupTemplateButton"] = "valueTemplate_groupTemplateButton";
    ValueTemplateAttributes["AddGroupButton"] = "valueTemplate_addGroupButton";
    ValueTemplateAttributes["SelectionButtons"] = "valueTemplate_selectionButtons";
    ValueTemplateAttributes["SingleFieldTabSearch"] = "valueTemplate_singleField_tab_search";
    ValueTemplateAttributes["SingleFieldTabCreate"] = "valueTemplate_singleField_tab_create";
    ValueTemplateAttributes["SingleFieldTabEdit"] = "valueTemplate_singleField_tab_edit";
    ValueTemplateAttributes["SingleFieldTabSave"] = "valueTemplate_singleField_tab_save";
    ValueTemplateAttributes["SingleFieldTabCancel"] = "valueTemplate_singleField_tab_cancel";
    ValueTemplateAttributes["MultipleFieldsTabCreate"] = "valueTemplate_multipleFields_tab_create";
    ValueTemplateAttributes["MultipleFieldsTabEdit"] = "valueTemplate_multipleFields_tab_edit";
    ValueTemplateAttributes["MultipleFieldsTabCancel"] = "valueTemplate_multipleFields_tab_cancel";
    ValueTemplateAttributes["CreateTemplateFormFieldSelect"] = "valueTemplate_createTeamplateForm_fieldSelect";
    ValueTemplateAttributes["CreateTemplateFormTemplateText"] = "valueTemplate_createTeamplateForm_templateText";
    ValueTemplateAttributes["CreateTemplateFormGroupSelect"] = "valueTemplate_createTeamplateForm_groupSelect";
    ValueTemplateAttributes["CreateTemplateFormNewGroupName"] = "valueTemplate_createTeamplateForm_newGroupName";
    ValueTemplateAttributes["CreateTemplateFormIsSubgroupCheckbox"] = "valueTemplate_createTeamplateForm_isSubgroup";
    ValueTemplateAttributes["CreateTemplateFormMoveToGroup"] = "valueTemplate_createTeamplateForm_moveToGroup";
    ValueTemplateAttributes["CreateTemplateFormCreate"] = "valueTemplate_createTeamplateForm_create";
    ValueTemplateAttributes["CreateTemplateFormCancel"] = "valueTemplate_createTeamplateForm_cancel";
    ValueTemplateAttributes["EditGroupFormGroupName"] = "valueTemplate_editGroupForm_groupName";
    ValueTemplateAttributes["EditGroupFormSave"] = "valueTemplate_editGroupForm_save";
    ValueTemplateAttributes["EditGroupFormCancel"] = "valueTemplate_editGroupForm_cancel";
    ValueTemplateAttributes["EditGroupFormRemove"] = "valueTemplate_editGroupForm_remove";
    ValueTemplateAttributes["EditTemplateFormTemplateText"] = "valueTemplate_editTemplateForm_templateText";
    ValueTemplateAttributes["EditTemplateFormGroupSelect"] = "valueTemplate_editTemplateForm_groupSelect";
    ValueTemplateAttributes["EditTemplateFormGroupSave"] = "valueTemplate_editTemplateForm_save";
    ValueTemplateAttributes["EditTemplateFormGroupCancel"] = "valueTemplate_editTemplateForm_cancel";
    ValueTemplateAttributes["EditTemplateFormGroupRemove"] = "valueTemplate_editTemplateForm_remove";
    ValueTemplateAttributes["GroupFieldFormRemove"] = "valueTemplate_groupFieldForm_remove";
    ValueTemplateAttributes["GroupFieldFormUndo"] = "valueTemplate_groupFieldForm_undo";
    ValueTemplateAttributes["GroupFieldFormFieldSelect"] = "valueTemplate_groupFieldForm_fieldSelect";
    ValueTemplateAttributes["GroupFieldFormTemplateText"] = "valueTemplate_groupFieldForm_templateText";
    ValueTemplateAttributes["GroupTemplateFormTemplateName"] = "valueTemplate_groupTemplateForm_templateName";
    ValueTemplateAttributes["GroupTemplateFormAddField"] = "valueTemplate_groupTemplateForm_addField";
    ValueTemplateAttributes["GroupTemplateFormCreateOrSave"] = "valueTemplate_groupTemplateForm_createOrSave";
    ValueTemplateAttributes["GroupTemplateFormRemove"] = "valueTemplate_groupTemplateForm_remove";
    ValueTemplateAttributes["NoTemplatesCreate"] = "valueTemplate_noTemplates_create";
    ValueTemplateAttributes["NoTemplatesCreateFromEntry"] = "valueTemplate_noTemplates_createFromEntry";
    ValueTemplateAttributes["MultipleFieldsTabCreateFromEntry"] = "valueTemplate_multipleFields_tab_createFromEntry";
    ValueTemplateAttributes["CreateFromEntryPopupTemplateName"] = "valueTemplate_createFromEntryPopup_templateName";
    ValueTemplateAttributes["CreateFromEntryPopupCreate"] = "valueTemplate_createFromEntryPopup_create";
    ValueTemplateAttributes["CreateFromEntryPopupCancel"] = "valueTemplate_createFromEntryPopup_cancel";
    ValueTemplateAttributes["ConfirmRemove"] = "valueTemplate_confirmRemove";
    ValueTemplateAttributes["CancelRemove"] = "valueTemplate_cancelRemove";
    ValueTemplateAttributes["SaveGroupTemplate"] = "valueTemplate_saveGroupTemplate";
})(ValueTemplateAttributes || (ValueTemplateAttributes = {}));
export var TableWithControlsIds;
(function (TableWithControlsIds) {
    TableWithControlsIds["Root"] = "tableWithControls";
})(TableWithControlsIds || (TableWithControlsIds = {}));
export var VirtualTableIds;
(function (VirtualTableIds) {
    VirtualTableIds["Root"] = "virtualTable";
})(VirtualTableIds || (VirtualTableIds = {}));
//  page attributes
export var PageAttributes;
(function (PageAttributes) {
    PageAttributes["A"] = "_";
})(PageAttributes || (PageAttributes = {}));
//  DentalFormulaEditor attributes
export var DentalFormulaEditorTestIds;
(function (DentalFormulaEditorTestIds) {
    DentalFormulaEditorTestIds["Root"] = "dentalFormulaEditor";
    DentalFormulaEditorTestIds["SelectionFormulaButton"] = "selectionFormulaButton";
    DentalFormulaEditorTestIds["SelectionMixedFormulaButton"] = "selectionMixedFormulaButton";
    DentalFormulaEditorTestIds["ActionButton"] = "actionButton";
    DentalFormulaEditorTestIds["MixedFormulaChooseBlock"] = "mixedFormulaChooseBlock";
    DentalFormulaEditorTestIds["ClearSelectionButton"] = "clearSelectionButton";
})(DentalFormulaEditorTestIds || (DentalFormulaEditorTestIds = {}));
export var DentalObjectivePageTestIds;
(function (DentalObjectivePageTestIds) {
    DentalObjectivePageTestIds["LockedSelect"] = "lockedSelect";
})(DentalObjectivePageTestIds || (DentalObjectivePageTestIds = {}));
export var DentalProblemListTestIds;
(function (DentalProblemListTestIds) {
    DentalProblemListTestIds["Root"] = "dentalProblemList";
    DentalProblemListTestIds["NewCondition"] = "newCondition";
})(DentalProblemListTestIds || (DentalProblemListTestIds = {}));
export var DentalObservationsTestIds;
(function (DentalObservationsTestIds) {
    DentalObservationsTestIds["Root"] = "dentalObservations";
    DentalObservationsTestIds["ObservationField"] = "dentalObservationField";
})(DentalObservationsTestIds || (DentalObservationsTestIds = {}));
export var DentalConditionModalTestIds;
(function (DentalConditionModalTestIds) {
    DentalConditionModalTestIds["Name"] = "name";
    DentalConditionModalTestIds["ClinicalStatus"] = "clinicalStatus";
    DentalConditionModalTestIds["VerificationStatus"] = "verificationStatus";
    DentalConditionModalTestIds["Severity"] = "Severity";
    DentalConditionModalTestIds["Icd"] = "icd";
    DentalConditionModalTestIds["DiagnosticReport"] = "diagnosticReport";
    DentalConditionModalTestIds["StatusLocalis"] = "statusLocalis";
    DentalConditionModalTestIds["Next"] = "next";
    DentalConditionModalTestIds["Cancel"] = "cancel";
})(DentalConditionModalTestIds || (DentalConditionModalTestIds = {}));
export var DentalPlanTestIds;
(function (DentalPlanTestIds) {
    DentalPlanTestIds["Root"] = "dentalPlan";
    DentalPlanTestIds["NewRequest"] = "newRequest";
    DentalPlanTestIds["AddStagesButton"] = "dentalPlan_addStagesButton";
    DentalPlanTestIds["EditStagesButton"] = "dentalPlan_editStagesButton";
})(DentalPlanTestIds || (DentalPlanTestIds = {}));
export var DentalAnamnesTestIds;
(function (DentalAnamnesTestIds) {
    DentalAnamnesTestIds["Opener"] = "dentalAnamnes_opener";
    DentalAnamnesTestIds["TextAreaAnamnes"] = "dentalAnamnes_textarea";
})(DentalAnamnesTestIds || (DentalAnamnesTestIds = {}));
export var DentalStagesTestIds;
(function (DentalStagesTestIds) {
    DentalStagesTestIds["StageTitleInput"] = "dentalStages_stageItemInput";
    DentalStagesTestIds["AddButton"] = "dentalStages_addButton";
    DentalStagesTestIds["DeleteButton"] = "dentalStages_deleteButton";
    DentalStagesTestIds["CreateButton"] = "dentalStages_createButton";
    DentalStagesTestIds["CancelButton"] = "dentalStages_cancelButton";
})(DentalStagesTestIds || (DentalStagesTestIds = {}));
//  DentalFormula attributes
export var DentalFormulaTestIds;
(function (DentalFormulaTestIds) {
    DentalFormulaTestIds["Root"] = "dentalFormula";
    DentalFormulaTestIds["Tooth"] = "tooth";
    DentalFormulaTestIds["ToothSurface"] = "toothSurface";
    DentalFormulaTestIds["ToothIconRoot"] = "toothIconRoot";
    DentalFormulaTestIds["ToothIconCrown"] = "toothIconCrown";
    DentalFormulaTestIds["SurfaceIcon"] = "surfaceIcon";
    DentalFormulaTestIds["UpperJawSelectButton"] = "upperJawSelectButton";
    DentalFormulaTestIds["LowerJawSelectButton"] = "lowerJawSelectButton";
})(DentalFormulaTestIds || (DentalFormulaTestIds = {}));
export var DentalServiceRequestFormAttributes;
(function (DentalServiceRequestFormAttributes) {
    DentalServiceRequestFormAttributes["PerformerTypeSelect"] = "dentalServiceRequestForm_performerTypeSelect";
    DentalServiceRequestFormAttributes["PerformerSelect"] = "dentalServiceRequestForm_performerSelect";
    DentalServiceRequestFormAttributes["ProcedureSelect"] = "dentalServiceRequestForm_procedureSelect";
    DentalServiceRequestFormAttributes["InstructionsTextArea"] = "dentalServiceRequestForm_instructionsTextArea";
    DentalServiceRequestFormAttributes["AddButton"] = "dentalServiceRequestForm_addButton";
    DentalServiceRequestFormAttributes["SaveButton"] = "dentalServiceRequestForm_saveButton";
    DentalServiceRequestFormAttributes["DeleteButton"] = "dentalServiceRequestForm_deleteButton";
})(DentalServiceRequestFormAttributes || (DentalServiceRequestFormAttributes = {}));
export var DentalAssessmentConditionsTestIds;
(function (DentalAssessmentConditionsTestIds) {
    DentalAssessmentConditionsTestIds["Opener"] = "dentalAssessmentConditions_opener";
})(DentalAssessmentConditionsTestIds || (DentalAssessmentConditionsTestIds = {}));
export var DentalAssessmentConditionsItemTestIds;
(function (DentalAssessmentConditionsItemTestIds) {
    DentalAssessmentConditionsItemTestIds["ClinicalStatus"] = "assessment_clinicalStatus";
    DentalAssessmentConditionsItemTestIds["VerificationStatus"] = "assessment_verificationStatus";
    DentalAssessmentConditionsItemTestIds["Severity"] = "assessment_severity";
    DentalAssessmentConditionsItemTestIds["Icd"] = "assessment_icd";
    DentalAssessmentConditionsItemTestIds["DiagnosticReport"] = "assessment_diagnosticReport";
})(DentalAssessmentConditionsItemTestIds || (DentalAssessmentConditionsItemTestIds = {}));
export var ChangeLanguageAttributes;
(function (ChangeLanguageAttributes) {
    ChangeLanguageAttributes["ChangeToRussian"] = "changeTo_russian";
    ChangeLanguageAttributes["ChangeToArmenian"] = "changeTo_armenian";
    ChangeLanguageAttributes["ChangeToEnglish"] = "changeTo_english";
    ChangeLanguageAttributes["ChangeToGeorgian"] = "changeTo_georgian";
})(ChangeLanguageAttributes || (ChangeLanguageAttributes = {}));
export var AccountingPageAttributes;
(function (AccountingPageAttributes) {
    AccountingPageAttributes["TabReport"] = "accounting-page_tab-report";
    AccountingPageAttributes["OrganizationData"] = "accounting-page_organization-data";
})(AccountingPageAttributes || (AccountingPageAttributes = {}));
// Configuration page attributes. The FeatureName suffix on Feature and
// FeatureUsersSelect is appended at the JSX site so each of the feature
// blocks rendered on /configuration is addressable independently.
export var ConfigurationPageAttributes;
(function (ConfigurationPageAttributes) {
    ConfigurationPageAttributes["Root"] = "configurationPage_root";
    ConfigurationPageAttributes["Feature"] = "configurationPage_feature";
    ConfigurationPageAttributes["FeatureUsersSelect"] = "configurationPage_feature_usersSelect";
})(ConfigurationPageAttributes || (ConfigurationPageAttributes = {}));
export var PromptsPageAttributes;
(function (PromptsPageAttributes) {
    PromptsPageAttributes["Root"] = "promptsPage_root";
})(PromptsPageAttributes || (PromptsPageAttributes = {}));
export var PlanListPageAttributes;
(function (PlanListPageAttributes) {
    PlanListPageAttributes["Root"] = "planListPage_root";
})(PlanListPageAttributes || (PlanListPageAttributes = {}));
export var PlanSubscriptionsPageAttributes;
(function (PlanSubscriptionsPageAttributes) {
    PlanSubscriptionsPageAttributes["Root"] = "planSubscriptionsPage_root";
})(PlanSubscriptionsPageAttributes || (PlanSubscriptionsPageAttributes = {}));
export var ReportPageAttributes;
(function (ReportPageAttributes) {
    ReportPageAttributes["LegalEntitySelect"] = "report-page_legal-entity-select";
    ReportPageAttributes["OrganizationsSelect"] = "report-page_organizations-select";
    ReportPageAttributes["FromDate"] = "report-page_from-date";
    ReportPageAttributes["ToDate"] = "report-page_to-date";
    ReportPageAttributes["CreateReportButton"] = "report-page_create-report-button";
})(ReportPageAttributes || (ReportPageAttributes = {}));
export var LaboratoryAdminPageAttributes;
(function (LaboratoryAdminPageAttributes) {
    LaboratoryAdminPageAttributes["LaboratoryCostPrices"] = "laboratoryAdminPage_tabs_laboratoryCostPrices";
    LaboratoryAdminPageAttributes["BioCodes"] = "laboratoryAdminPage_tabs_bioCodes";
    LaboratoryAdminPageAttributes["Laboratory"] = "laboratoryAdminPage_tabs_laboratory";
    LaboratoryAdminPageAttributes["LaboratoryService"] = "laboratoryAdminPage_tabs_laboratoryService";
    LaboratoryAdminPageAttributes["LaboratoryReferencesTable"] = "laboratoryAdminPage_tabs_laboratoryReferencesTable";
    LaboratoryAdminPageAttributes["SearchButton"] = "laboratoryAdminPage_searchButton";
    LaboratoryAdminPageAttributes["SearchInput"] = "laboratoryAdminPage_searchInput";
})(LaboratoryAdminPageAttributes || (LaboratoryAdminPageAttributes = {}));
export var LaboratoryCostPricesAttributes;
(function (LaboratoryCostPricesAttributes) {
    LaboratoryCostPricesAttributes["SaveButton"] = "laboratoryCostPrices_saveButton";
    LaboratoryCostPricesAttributes["CancelButton"] = "laboratoryCostPrices_cancelButton";
})(LaboratoryCostPricesAttributes || (LaboratoryCostPricesAttributes = {}));
export var TagListPageAttributes;
(function (TagListPageAttributes) {
    TagListPageAttributes["EditButton"] = "tagListPage_editButton";
    TagListPageAttributes["DeleteButton"] = "tagListPage_deleteButton";
    TagListPageAttributes["SearchInput"] = "tagListPage_searchInput";
    TagListPageAttributes["SearchButton"] = "tagListPage_searchButton";
    TagListPageAttributes["AddButton"] = "tagListPage_addButton";
    TagListPageAttributes["SaveButton"] = "tagListPage_saveButton";
    TagListPageAttributes["CancelButton"] = "tagListPage_cancelButton";
})(TagListPageAttributes || (TagListPageAttributes = {}));
export var SpecialityListPageAttributes;
(function (SpecialityListPageAttributes) {
    SpecialityListPageAttributes["EditButton"] = "specialityListPage_editButton";
    SpecialityListPageAttributes["ArchiveButton"] = "specialityListPage_archiveButton";
    SpecialityListPageAttributes["SearchInput"] = "specialityListPage_searchInput";
    SpecialityListPageAttributes["SearchButton"] = "specialityListPage_searchButton";
    SpecialityListPageAttributes["AddButton"] = "specialityListPage_addButton";
    SpecialityListPageAttributes["SaveButton"] = "specialityListPage_saveButton";
    SpecialityListPageAttributes["CancelButton"] = "specialityListPage_cancelButton";
    SpecialityListPageAttributes["EpisodeEditButton"] = "specialityListPage_episodeEditButton";
    SpecialityListPageAttributes["EpisodeSpecialtyFilter"] = "specialityListPage_episodeSpecialtyFilter";
    SpecialityListPageAttributes["EpisodeSaveButton"] = "specialityListPage_episodeSaveButton";
    SpecialityListPageAttributes["EpisodeCancelButton"] = "specialityListPage_episodeCancelButton";
})(SpecialityListPageAttributes || (SpecialityListPageAttributes = {}));
export var BillingRenderedServicesPageAttributes;
(function (BillingRenderedServicesPageAttributes) {
    BillingRenderedServicesPageAttributes["SearchInput"] = "billingRenderedServicesPage_searchInput";
    BillingRenderedServicesPageAttributes["SearchButton"] = "billingRenderedServicesPage_searchButton";
})(BillingRenderedServicesPageAttributes || (BillingRenderedServicesPageAttributes = {}));
export var AttachmentProcessingPageAttributes;
(function (AttachmentProcessingPageAttributes) {
    AttachmentProcessingPageAttributes["SearchInput"] = "attachmentProcessingPage_searchInput";
    AttachmentProcessingPageAttributes["SearchButton"] = "attachmentProcessingPage_searchButton";
    AttachmentProcessingPageAttributes["InsurerAbbreviationFilter"] = "attachmentProcessingPage_insurerAbbreviationFilter";
    AttachmentProcessingPageAttributes["PaymentTypeFilter"] = "attachmentProcessingPage_paymentTypeFilter";
    AttachmentProcessingPageAttributes["StatusFilter"] = "attachmentProcessingPage_statusFilter";
    AttachmentProcessingPageAttributes["ActionFilter"] = "attachmentProcessingPage_actionFilter";
})(AttachmentProcessingPageAttributes || (AttachmentProcessingPageAttributes = {}));
export var BioCodesPageAttributes;
(function (BioCodesPageAttributes) {
    BioCodesPageAttributes["SearchInput"] = "bioCodesPage_searchInput";
    BioCodesPageAttributes["SearchButton"] = "bioCodesPage_searchButton";
    BioCodesPageAttributes["AddButton"] = "bioCodesPage_addButton";
    BioCodesPageAttributes["SaveButton"] = "bioCodesPage_saveButton";
    BioCodesPageAttributes["CancelButton"] = "bioCodesPage_cancelButton";
})(BioCodesPageAttributes || (BioCodesPageAttributes = {}));
export var ProtestPageAttributes;
(function (ProtestPageAttributes) {
    ProtestPageAttributes["AddButton"] = "protestPage_addButton";
    ProtestPageAttributes["EditButton"] = "protestPage_editButton";
    ProtestPageAttributes["SaveButton"] = "protestPage_saveButton";
    ProtestPageAttributes["SearchInput"] = "protestPage_searchInput";
    ProtestPageAttributes["CancelButton"] = "protestPage_cancelButton";
})(ProtestPageAttributes || (ProtestPageAttributes = {}));
export var PatientPolicySearchPageAttributes;
(function (PatientPolicySearchPageAttributes) {
    PatientPolicySearchPageAttributes["SearchButton"] = "patientPolicySearchPage_searchButton";
    PatientPolicySearchPageAttributes["SearchInput"] = "patientPolicySearchPage_searchInput";
})(PatientPolicySearchPageAttributes || (PatientPolicySearchPageAttributes = {}));
export var ProtestItemPageAttributes;
(function (ProtestItemPageAttributes) {
    ProtestItemPageAttributes["SearchInput"] = "protestPage_searchInput";
    ProtestItemPageAttributes["SearchButton"] = "protestPage_searchButton";
    ProtestItemPageAttributes["FilterRenderedServiceAuthorId"] = "protestPage_filterRenderedServiceId";
    ProtestItemPageAttributes["FilterReferralAuthorId"] = "protestPage_filterReferralId";
    ProtestItemPageAttributes["TableCreationButton"] = "protestPage_tableCreationButton";
    ProtestItemPageAttributes["TableCancelButton"] = "protestPage_tableCancelButton";
    ProtestItemPageAttributes["TableRowEditButton"] = "protestPage_tableRowEditButton";
})(ProtestItemPageAttributes || (ProtestItemPageAttributes = {}));
export var PatientReservationPageAttributes;
(function (PatientReservationPageAttributes) {
    PatientReservationPageAttributes["SaveButton"] = "patientReservationPage_saveButton";
})(PatientReservationPageAttributes || (PatientReservationPageAttributes = {}));
export var TasksPageAttributes;
(function (TasksPageAttributes) {
    TasksPageAttributes["NavigationTabs"] = "tasksPage_navigationTabs";
    TasksPageAttributes["AuthorTab"] = "tasksPage_tabs_author";
    TasksPageAttributes["ExecutorTab"] = "tasksPage_tabs_executor";
    TasksPageAttributes["AddExecutorsAction"] = "tasksPage_addExecutorsAction";
    TasksPageAttributes["RemoveExecutorsAction"] = "tasksPage_removeExecutorsAction";
    TasksPageAttributes["ExecutorsMenuSubmit"] = "tasksPage_executorsMenuSubmit";
})(TasksPageAttributes || (TasksPageAttributes = {}));
export var MedicalCasePageAttributes;
(function (MedicalCasePageAttributes) {
    MedicalCasePageAttributes["NavigationTabs"] = "medicalCasePage_navigationTabs";
    MedicalCasePageAttributes["EpisodesWithTasksTab"] = "medicalCasePage_tabs_episodesWithTasks";
    MedicalCasePageAttributes["EpisodesWithSpecialtyTab"] = "medicalCasePage_tabs_episodesWithSpecialty";
})(MedicalCasePageAttributes || (MedicalCasePageAttributes = {}));
export var LegalEntitiesPriceListPage;
(function (LegalEntitiesPriceListPage) {
    LegalEntitiesPriceListPage["SearchInput"] = "legalEntitiesPriceListPage_searchInput";
    LegalEntitiesPriceListPage["SearchButton"] = "legalEntitiesPriceListPage_searchButton";
    LegalEntitiesPriceListPage["AddButton"] = "legalEntitiesPriceListPage_addButton";
    LegalEntitiesPriceListPage["SaveButton"] = "legalEntitiesPriceListPage_saveButton";
    LegalEntitiesPriceListPage["CancelButton"] = "legalEntitiesPriceListPage_cancelButton";
})(LegalEntitiesPriceListPage || (LegalEntitiesPriceListPage = {}));
export var LegalEntitiesPriceTableCreationMenu;
(function (LegalEntitiesPriceTableCreationMenu) {
    LegalEntitiesPriceTableCreationMenu["Button"] = "pricePageTableCreationMenu_button";
    LegalEntitiesPriceTableCreationMenu["SaveButton"] = "pricePageTableCreationMenu_buttonSave";
    LegalEntitiesPriceTableCreationMenu["CancelButton"] = "pricePageTableCreationMenu_buttonCancel";
})(LegalEntitiesPriceTableCreationMenu || (LegalEntitiesPriceTableCreationMenu = {}));
export var DashboardServicesPageAttributes;
(function (DashboardServicesPageAttributes) {
    DashboardServicesPageAttributes["NavigationTabs"] = "dashboardServicesPage_navigationTabs";
    DashboardServicesPageAttributes["SearchInput"] = "dashboardServicesPage_searchInput";
    DashboardServicesPageAttributes["SearchButton"] = "dashboardServicesPage_searchButton";
})(DashboardServicesPageAttributes || (DashboardServicesPageAttributes = {}));
export var MaxPaymentAmountPageAttributes;
(function (MaxPaymentAmountPageAttributes) {
    MaxPaymentAmountPageAttributes["CreationMenuCancelButton"] = "maxPaymentAmountPage_creationMenuCancelButton";
    MaxPaymentAmountPageAttributes["CreationMenuSaveButton"] = "maxPaymentAmountPage_creationMenuSaveButton";
    MaxPaymentAmountPageAttributes["RowEditButton"] = "maxPaymentAmountPage_rowEditButton";
    MaxPaymentAmountPageAttributes["AddButton"] = "maxPaymentAmountPage_addButton";
})(MaxPaymentAmountPageAttributes || (MaxPaymentAmountPageAttributes = {}));
export var PaymentsByLegalEntityPageAttributes;
(function (PaymentsByLegalEntityPageAttributes) {
    PaymentsByLegalEntityPageAttributes["SearchButton"] = "paymentsByLegalEntityPage_searchButton";
    PaymentsByLegalEntityPageAttributes["SearchInput"] = "paymentsByLegalEntityPage_searchInput";
    PaymentsByLegalEntityPageAttributes["UploadButton"] = "paymentsByLegalEntityPage_uploadButton";
    PaymentsByLegalEntityPageAttributes["SummaryAmount"] = "paymentsByLegalEntityPage_summaryAmount";
    PaymentsByLegalEntityPageAttributes["PopupSelectLegalEntity"] = "paymentsByLegalEntityPage_popupSelectLegalEntity";
    PaymentsByLegalEntityPageAttributes["PopupCancelButton"] = "paymentsByLegalEntityPage_popupCancelButton";
    PaymentsByLegalEntityPageAttributes["PopupGenerateReportButton"] = "paymentsByLegalEntityPage_popupGenerateReportButton";
})(PaymentsByLegalEntityPageAttributes || (PaymentsByLegalEntityPageAttributes = {}));
export var LaboratoryServicePageAttributes;
(function (LaboratoryServicePageAttributes) {
    LaboratoryServicePageAttributes["SearchInput"] = "laboratoryServicePage_searchInput";
    LaboratoryServicePageAttributes["SearchButton"] = "laboratoryServicePage_searchButton";
    LaboratoryServicePageAttributes["EditButton"] = "laboratoryServicePage_editButton";
    LaboratoryServicePageAttributes["AddButton"] = "laboratoryServicePage_addButton";
    LaboratoryServicePageAttributes["SaveButton"] = "laboratoryServicePage_saveButton";
    LaboratoryServicePageAttributes["CancelButton"] = "laboratoryServicePage_cancelButton";
})(LaboratoryServicePageAttributes || (LaboratoryServicePageAttributes = {}));
export var TaskDevicePopup;
(function (TaskDevicePopup) {
    TaskDevicePopup["PopupSelectDevice"] = "paymentsByLegalEntityPage_popupSelectDevice";
    TaskDevicePopup["PopupCancelButton"] = "paymentsByLegalEntityPage_popupCancelButton";
    TaskDevicePopup["PopupGenerateReportButton"] = "paymentsByLegalEntityPage_popupGenerateReportButton";
    TaskDevicePopup["AlreadyQueuedBanner"] = "taskDevicePopup_alreadyQueuedBanner";
    TaskDevicePopup["SendFailedBanner"] = "taskDevicePopup_sendFailedBanner";
    TaskDevicePopup["TaskSentBanner"] = "taskDevicePopup_taskSentBanner";
    TaskDevicePopup["DeleteTaskButton"] = "taskDevicePopup_deleteTaskButton";
})(TaskDevicePopup || (TaskDevicePopup = {}));
export var EntryListPageAttributes;
(function (EntryListPageAttributes) {
    EntryListPageAttributes["ArchiveExportButton"] = "entryListPage_archiveExportButton";
})(EntryListPageAttributes || (EntryListPageAttributes = {}));
export var MedicalCasesAttributes;
(function (MedicalCasesAttributes) {
    MedicalCasesAttributes["AddButton"] = "medicalCasesPage_addButton";
    MedicalCasesAttributes["CurrentEntryList"] = "medicalCasesPage_currentEntryList";
})(MedicalCasesAttributes || (MedicalCasesAttributes = {}));
export var MedicalCaseCardAttributes;
(function (MedicalCaseCardAttributes) {
    MedicalCaseCardAttributes["Card"] = "medicalCaseCard";
    MedicalCaseCardAttributes["MenuDetails"] = "medicalCaseCard_menuDetails";
    MedicalCaseCardAttributes["MenuDelete"] = "medicalCaseCard_menuDelete";
    MedicalCaseCardAttributes["MenuDetach"] = "medicalCaseCard_menuDetach";
    MedicalCaseCardAttributes["MenuAttach"] = "medicalCaseCard_menuAttach";
})(MedicalCaseCardAttributes || (MedicalCaseCardAttributes = {}));
export var MedicalCaseWarnPopupAttributes;
(function (MedicalCaseWarnPopupAttributes) {
    MedicalCaseWarnPopupAttributes["ConfirmButton"] = "medicalCaseWarnPopup_confirm";
})(MedicalCaseWarnPopupAttributes || (MedicalCaseWarnPopupAttributes = {}));
export var WarnPopupAttributes;
(function (WarnPopupAttributes) {
    WarnPopupAttributes["EpisodesTransferSelect"] = "warnPopup_episodesTransferSelect";
})(WarnPopupAttributes || (WarnPopupAttributes = {}));
export var PassEpisodesPopupAttributes;
(function (PassEpisodesPopupAttributes) {
    PassEpisodesPopupAttributes["Select"] = "passEpisodesPopup_select";
    PassEpisodesPopupAttributes["ConfirmButton"] = "passEpisodesPopup_confirm";
    PassEpisodesPopupAttributes["CancelButton"] = "passEpisodesPopup_cancel";
})(PassEpisodesPopupAttributes || (PassEpisodesPopupAttributes = {}));
export var EditUserProfileAttributes;
(function (EditUserProfileAttributes) {
    EditUserProfileAttributes["PassEpisodesButton"] = "editUserProfile_passEpisodesButton";
    EditUserProfileAttributes["OwnEhr"] = "editUserProfile_ownEhr";
    EditUserProfileAttributes["OwnEhrRemoveButton"] = "editUserProfile_ownEhrRemoveButton";
    EditUserProfileAttributes["OwnEhrPatientSelect"] = "editUserProfile_ownEhrPatientSelect";
})(EditUserProfileAttributes || (EditUserProfileAttributes = {}));
export var RecurringSubscriptionMenuAttributes;
(function (RecurringSubscriptionMenuAttributes) {
    RecurringSubscriptionMenuAttributes["DoctorSelect"] = "recurringSubscriptionMenu_doctorSelect";
})(RecurringSubscriptionMenuAttributes || (RecurringSubscriptionMenuAttributes = {}));
export var CooperatorTableAttributes;
(function (CooperatorTableAttributes) {
    CooperatorTableAttributes["AddButton"] = "cooperatorTable_addButton";
    CooperatorTableAttributes["CreationMenuSaveButton"] = "cooperatorTable_creationMenuSaveButton";
    CooperatorTableAttributes["CreationMenuCancelButton"] = "cooperatorTable_creationMenuCancelButton";
})(CooperatorTableAttributes || (CooperatorTableAttributes = {}));
